// src/table/AppVentaReactTable.jsx
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import jwt_decode from "jwt-decode";
import styled from "styled-components";
import { useSortBy, usePagination } from "react-table";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { Modal, Button, Table as BsTable, Spinner } from "react-bootstrap";

import ModalSeguimientoCliente from "../components/ModalSeguimientoCliente";
import ModalPagoVenta from "../components/ModalPagoVenta";
import ModalEditarVentaCompleta from "../components/ModalEditarVentaCompleta";
import ModalComprobantesVenta from "../components/ModalComprobantesVenta";
import ModalCompletarReceptor from "../components/ModalCompletarReceptor";

import Table from "./TableContainer";
import "../css/tablecomandas.css";

import ridersLogo from "../images/ridersmiami-logo.png";

import {
  getVentas,
  getVentaById,
  anularVenta,
  cambiarEstadoVenta,
  marcarWhatsappVenta,
} from "../helpers/rutaVentas";

import { getPagosVenta } from "../helpers/rutaPagoVentas";
import { getSeguimientosClientes } from "../helpers/rutaSeguimientosClientes";

const Styles = styled.div`

  /* Colores recepción pendiente - CLARO */
  --recepcion-pendiente-bg: #fff1dc;
  --recepcion-pendiente-hover: #ffe5bf;
  --recepcion-pendiente-text: #111827;
  --recepcion-pendiente-border: #f6c47c;

  .table-container {
    width: 100%;
    max-height: calc(100vh - 285px);
    overflow: auto;
    border: 1px solid var(--app-border, #d9dee7);
    border-radius: 10px;
    background: var(--app-card, #fff);
  }

  .table-container table {
    width: max-content !important;
    min-width: 2300px;
    table-layout: fixed !important;
    border-collapse: collapse !important;
    margin-bottom: 0 !important;
  }

  .table-container thead th {
    position: sticky;
    top: 0;
    z-index: 4;
    background: linear-gradient(180deg, #2f6fe4 0%, #214fae 100%) !important;
    color: #fff !important;
    font-size: 12px !important;
    font-weight: 700 !important;
    line-height: 1.15 !important;
    text-align: center !important;
    vertical-align: middle !important;
    padding: 7px 6px !important;
    border: 1px solid #1c469e !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  .table-container thead tr:nth-child(2) {
    display: none !important;
  }

  .table-container tbody td {
    height: 40px;
    padding: 6px 8px !important;
    border: 1px solid var(--app-border-soft, #dde2e8) !important;
    vertical-align: middle !important;
    font-size: 13px !important;
    line-height: 1.2 !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    background: var(--app-table-row, #fff) !important;
    color: var(--app-text, #111827) !important;
  }

  .table-container tbody tr:nth-child(odd) td {
    background: var(--app-table-row-alt, #f8fafc) !important;
  }

  .table-container tbody tr:hover td {
    background: rgba(47, 128, 255, 0.12) !important;
  }

  .table-container tfoot th,
  .table-container tfoot td {
    background: #ffffff !important;
    color: #0f172a !important;
    border-color: #dbe3ef !important;
  }

  html[data-theme="dark"] & {
    --recepcion-pendiente-bg: #4a4d52;
    --recepcion-pendiente-hover: #585c63;
    --recepcion-pendiente-text: #ffffff;
    --recepcion-pendiente-border: #70757d;
  }

  html[data-theme="dark"] & .card,
  html[data-theme="dark"] & .card-body {
    background: var(--app-card, #0f1b2d) !important;
    color: var(--app-text, #f8fafc) !important;
  }

  html[data-theme="dark"] & .table-container {
    border-color: #2a3f60 !important;
    background: #0f1b2d !important;
  }

  html[data-theme="dark"] & .table-container tbody td {
    background: #0f1b2d !important;
    color: #f8fafc !important;
    border-color: #2a3f60 !important;
  }

  html[data-theme="dark"] & .table-container tbody tr:nth-child(odd) td {
    background: #10213a !important;
  }

  html[data-theme="dark"] & .table-container tbody tr:nth-child(even) td {
    background: #0d1b31 !important;
  }

  html[data-theme="dark"] & .table-container tbody tr:hover td {
    background: #18345a !important;
  }

  html[data-theme="dark"] & .table-container tfoot th,
  html[data-theme="dark"] & .table-container tfoot td {
    background: #10213a !important;
    color: #f8fafc !important;
    border-color: #2a3f60 !important;
    font-weight: 800 !important;
  }

  html[data-theme="dark"] & .table-container input,
  html[data-theme="dark"] & .table-container select {
    background: #09182a !important;
    color: #f8fafc !important;
    border-color: #2a3f60 !important;
  }

  html[data-theme="dark"] & .table-container button {
    background: #101f34;
    color: #f8fafc;
    border-color: #2a3f60;
  }

  html[data-theme="dark"] & .table-container button:not(:disabled):hover {
    background: #18345a;
    color: #ffffff;
  }

  .action-btn {
    width: 28px !important;
    height: 28px !important;
    padding: 0 !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    border-radius: 5px !important;
    font-size: 13px !important;
    line-height: 1 !important;
    margin: 0 auto !important;
    border: none !important;
  }

  .action-btn--view {
    background: #1565c0 !important;
    color: #fff !important;
  }

  .action-btn--pdf {
    background: #b71c1c !important;
    color: #fff !important;
  }

  .action-btn--cancel {
    background: #c62828 !important;
    color: #fff !important;
  }

  .action-btn--docs-empty {
    background: #6c757d !important;
    color: #fff !important;
  }

  .action-btn--docs-partial {
    background: #f0ad4e !important;
    color: #fff !important;
  }

  .action-btn--docs-full {
    background: #198754 !important;
    color: #fff !important;
  }
  .action-btn--pay {
    background: #198754 !important;
    color: #fff !important;
  }

  .action-btn--edit {
    background: #f0ad4e !important;
    color: #fff !important;
  }

  .action-btn--whatsapp {
    background: #25d366 !important;
    color: #fff !important;
  }

   .action-btn--seguimiento {
    background: #ffc107 !important;
    color: #111827 !important;
    border: none !important;
    font-weight: 900 !important;
  }

  .action-btn--seguimiento:hover {
    background: #e0a800 !important;
    color: #111827 !important;
  } 

  .action-btn {
    width: 30px !important;
    height: 30px !important;
    min-width: 30px !important;
    padding: 0 !important;
    border-radius: 6px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    font-size: 13px !important;
  }

  .action-btn--whatsapp {
    background: #25d366 !important;
    color: #fff !important;
    border: none !important;
  }

  .action-btn--whatsapp:hover {
    background: #1fb859 !important;
    color: #fff !important;
  }

   /* Forzar ancho columna WhatsApp */
  .table-container table th:nth-child(6),
  .table-container table td:nth-child(6) {
    width: 42px !important;
    min-width: 42px !important;
    max-width: 42px !important;
    padding-left: 2px !important;
    padding-right: 2px !important;
    text-align: center !important;
  }

  /* Por si el filtro aparece o reserva espacio */
  .table-container table th:nth-child(6) input {
    display: none !important;
  }

  /* Botón WhatsApp más compacto */
  .table-container table td:nth-child(6) .action-btn {
    width: 26px !important;
    height: 26px !important;
    min-width: 26px !important;
    padding: 0 !important;
    margin: 0 auto !important;
  }

  .estadoPago-PENDIENTE {
    background: #f8d7da;
    color: #721c24;
  }

  .estadoPago-PARCIAL {
    background: #fff3cd;
    color: #856404;
  }

  .estadoPago-PAGADO {
    background: #d4edda;
    color: #155724;
  }

  .estado-pill {
    display: inline-block;
    padding: 3px 8px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 700;
  }

  .estado-PENDIENTE {
    background: #fff3cd;
    color: #856404;
  }

  .estado-CONFIRMADA {
    background: #d1ecf1;
    color: #0c5460;
  }

  .estado-EN_PROCESO {
    background: #d6e9ff;
    color: #084298;
  }

  .estado-ENVIADA {
    background: #e2e3ff;
    color: #383d8f;
  }

  .estado-ENTREGADA {
    background: #d4edda;
    color: #155724;
  }

  .estado-ANULADA {
    background: #f8d7da;
    color: #721c24;
  }

  .th-center,

  .td-center {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .action-btn--small {
    width: 26px !important;
    height: 26px !important;
    min-width: 26px !important;
    padding: 0 !important;
    border-radius: 6px !important;
    font-size: 13px !important;
  }

  .action-btn--whatsapp {
    background: #25d366 !important;
    color: #fff !important;
    border: none !important;
  }

  .action-btn--whatsapp:hover {
    background: #1fb859 !important;
    color: #fff !important;
  }

  .action-btn--whatsapp-pending {
    background: #6c757d !important;
    color: #fff !important;
    border: none !important;
  }

  .action-btn--whatsapp-sent {
    background: #25d366 !important;
    color: #fff !important;
    border: none !important;
  }

  .action-btn--whatsapp-resend {
    background: #f0ad4e !important;
    color: #fff !important;
    border: none !important;
  }

  .action-btn--whatsapp-pending:hover,
  .action-btn--whatsapp-sent:hover,
  .action-btn--whatsapp-resend:hover {
    filter: brightness(0.92);
  }

  /* =========================================================
     VENTA CON RECEPCIÓN PENDIENTE
     ========================================================= */

  .table-container
  tbody
  tr.venta-recepcion-pendiente
  > td {
    /*
      También pisamos las variables Bootstrap
      porque la tabla usa table-striped.
    */
    --bs-table-bg: var(--recepcion-pendiente-bg) !important;
    --bs-table-accent-bg: var(--recepcion-pendiente-bg) !important;
    --bs-table-striped-bg: var(--recepcion-pendiente-bg) !important;

    background: var(--recepcion-pendiente-bg) !important;
    background-color: var(--recepcion-pendiente-bg) !important;

    color: var(--recepcion-pendiente-text) !important;
    border-color: var(--recepcion-pendiente-border) !important;

    /*
      Bootstrap usa box-shadow para pintar
      table-striped. Lo anulamos solamente
      en esta fila.
    */
    box-shadow: none !important;
  }

  .table-container
  tbody
  tr.venta-recepcion-pendiente
  > td:first-child {
    border-left: 4px solid #f59e0b !important;
  }

  .table-container
  tbody
  tr.venta-recepcion-pendiente:hover
  > td {
    --bs-table-bg: var(--recepcion-pendiente-hover) !important;
    --bs-table-accent-bg: var(--recepcion-pendiente-hover) !important;

    background: var(--recepcion-pendiente-hover) !important;
    background-color: var(--recepcion-pendiente-hover) !important;
  }

    /* =========================================================
    FORZAR RECEPCIÓN PENDIENTE EN DARK MODE
    ========================================================= */

  html[data-theme="dark"] &
  .table-container
  tbody
  tr.venta-recepcion-pendiente
  > td {
    --bs-table-bg: #4a4d52 !important;
    --bs-table-accent-bg: #4a4d52 !important;
    --bs-table-striped-bg: #4a4d52 !important;

    background: #514a3f !important;
    background-color: #4a4d52 !important;

    color: #ffffff !important;
    border-color: #70757d !important;

    box-shadow: none !important;
  }

  html[data-theme="dark"] &
  .table-container
  tbody
  tr.venta-recepcion-pendiente
  > td:first-child {
    border-left: 4px solid #f59e0b !important;
  }

  html[data-theme="dark"] &
  .table-container
  tbody
  tr.venta-recepcion-pendiente:hover
  > td {
    --bs-table-bg: #585c63 !important;
    --bs-table-accent-bg: #585c63 !important;

    background: #585c63 !important;
    background-color: #585c63 !important;
  }

    /* Mobile: en celular NO fijar columnas, que se mueva toda la tabla */
  @media (max-width: 768px) {
    .table-container {
      max-height: calc(100vh - 245px);
      overflow-x: auto !important;
      overflow-y: auto !important;
      -webkit-overflow-scrolling: touch;
    }

    .table-container table {
      min-width: 1900px !important;
      width: max-content !important;
    }

    .table-container thead th {
      position: sticky !important;
      top: 0 !important;
      left: auto !important;
      z-index: 4 !important;
    }

    .table-container tbody td,
    .table-container thead th {
      left: auto !important;
    }

    .table-container th,
    .table-container td {
      position: static !important;
    }

    .table-container thead th {
      position: sticky !important;
      top: 0 !important;
    }
  }

`;

/* ---------------- helpers ---------------- */



const clean = (v) => String(v ?? "").trim();

const getId = (v) => {
  if (!v) return "";
  if (typeof v === "object") return clean(v._id ?? v.id ?? v.value ?? "");
  return clean(v);
};

const getRoleUsuario = () => {
  const token = localStorage.getItem("token") || "";

  try {
    if (!token) return "";

    const decoded = jwt_decode(token);
    return decoded?.usuario?.role || decoded?.user?.role || decoded?.role || "";
  } catch {
    return "";
  }
};

const getSedeUsuario = () => {
  const token = localStorage.getItem("token") || "";

  try {
    if (!token) return "";

    const decoded = jwt_decode(token);

    const usuario =
      decoded?.usuario ||
      decoded?.user ||
      decoded ||
      {};

    return clean(usuario?.sede)
      .normalize("NFD")
      .replace(/\p{Diacritic}/gu, "")
      .toUpperCase()
      .replace(/[_-]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  } catch {
    return "";
  }
};

const esVentaMiamiPropia = (venta = {}) => {
  const sede = clean(venta?.sede)
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toUpperCase()
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  return sede === "MIAMI";
};

const filtrarVentasParaExportacion = (
  rows = []
) => {
  const lista = Array.isArray(rows)
    ? rows
    : [];

  const role = getRoleUsuario();
  const sede = getSedeUsuario();

  const esManagerMiami =
    role === "MANAGER_ROLE" &&
    sede === "MIAMI";

  /*
    Para ADMIN / ROOT / VENDEDOR
    no cambia absolutamente nada.
  */
  if (!esManagerMiami) {
    return lista;
  }

  /*
    Para reportes del Manager usamos
    exclusivamente la sede REAL guardada
    en la venta.

    No usamos getSedeVenta() porque esa
    función tiene fallback al vendedor.
  */
  return lista.filter(
    (venta) =>
      esVentaMiamiPropia(venta)
  );
};

const norm = (v) =>
  clean(v)
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase();

const digits = (v) => String(v ?? "").replace(/\D/g, "");

const textOrDash = (v) => {
  const s = clean(v);
  return s || "-";
};

const fmtDate = (v) => {
  if (!v) return "-";

  // Si viene de Mongo como ISO: 2026-06-01T00:00:00.000Z
  // tomamos la parte de fecha pura sin moverla por zona horaria.
  if (typeof v === "string") {
    const m = v.match(/^(\d{4})-(\d{2})-(\d{2})/);

    if (m) {
      return `${m[3]}/${m[2]}/${m[1]}`;
    }
  }

  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return String(v);

  return d.toLocaleDateString("es-AR");
};

const formatUSD = (v) => {
  const n = Number(v || 0);
  if (!Number.isFinite(n)) return "US$ 0.00";

  return n.toLocaleString("es-AR", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  });
};

const getNombreFinanciera = (financiera) => {
  if (!financiera) return "-";

  if (typeof financiera === "string") return financiera;

  return (
    clean(financiera.financiera) ||
    clean(financiera.razonsocial) ||
    "-"
  );
};

const resumenFinanciero = (venta = {}, resumenPago = {}) => {
  const totalVenta = Number(resumenPago?.totalVenta ?? venta?.totalUSD ?? 0);

  const totalPagadoUSD = Number(
    resumenPago?.totalPagadoUSD ?? venta?.totalPagadoUSD ?? 0
  );

  const totalAcreditadoUSD = Number(
    resumenPago?.totalAcreditadoUSD ?? venta?.totalAcreditadoUSD ?? 0
  );

  const saldoPendienteUSD = Math.max(totalVenta - totalAcreditadoUSD, 0);

  return {
    totalVenta,
    totalPagadoUSD,
    totalAcreditadoUSD,
    saldoPendienteUSD,
    estadoPago: resumenPago?.estadoPago || venta?.estadoPago || "PENDIENTE",
  };
};

const badgeAcreditacion = (estado) => {
  const e = clean(estado).toUpperCase();

  if (e === "ACREDITADO") return "badge bg-success";
  if (e === "PENDIENTE") return "badge bg-warning text-dark";
  if (e === "ANULADO") return "badge bg-danger";

  return "badge bg-secondary";
};

const badgeSeguimiento = (estado) => {
  const e = clean(estado).toUpperCase();

  if (e === "RESUELTO") return "badge bg-success";
  if (e === "EN_REVISION") return "badge bg-warning text-dark";
  if (e === "PENDIENTE") return "badge bg-danger";

  return "badge bg-secondary";
};

const badgePrioridadSeguimiento = (prioridad) => {
  const p = clean(prioridad).toUpperCase();

  if (p === "ALTA") return "badge bg-danger";

  return "badge bg-secondary";
};

const firmadoPagoTxt = (pago = {}) => {
  const medio = clean(pago.medioPago).toUpperCase();

  if (medio !== "CREDITO FINANCIERA") return "-";

  return pago.contratoFirmado ? "Sí" : "No";
};

const nombreCliente = (c = {}) => {
  if (!c || typeof c !== "object") return "-";

  const armado = [c.apellido1, c.apellido2, c.nombre]
    .map(clean)
    .filter(Boolean)
    .join(" ")
    .replace(/\s+/g, " ")
    .trim();

  return (
    armado ||
    clean(c.nombreCompleto) ||
    clean(c.razonsocial) ||
    clean(c.dni) ||
    "-"
  );
};


const nombreClienteFinanciacionPago = (pago = {}, clienteCompra = null) => {
  const cf = pago?.clienteFinanciacion;

  if (cf && typeof cf === "object") {
    return nombreCliente(cf);
  }

  if (clienteCompra && typeof clienteCompra === "object") {
    return nombreCliente(clienteCompra);
  }

  return "-";
};

const normalizarNombreComparacion = (v = "") =>
  clean(v)
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .replace(/\s+/g, " ")
    .trim()
    .toUpperCase();

const nombreGaranteSiEsDistinto = (pago = {}, clienteCompra = null) => {
  const cf = pago?.clienteFinanciacion;

  // Si no hay garante real cargado, no mostramos nada
  if (!cf || typeof cf !== "object") return "";

  const idGarante = getId(cf);
  const idCliente = getId(clienteCompra);

  // Si son el mismo ObjectId, ocultar
  if (idGarante && idCliente && idGarante === idCliente) return "";

  const nombreGarante = nombreCliente(cf);
  const nombreSolicitante = nombreCliente(clienteCompra);

  // Si tienen el mismo nombre, ocultar
  if (
    normalizarNombreComparacion(nombreGarante) &&
    normalizarNombreComparacion(nombreGarante) ===
      normalizarNombreComparacion(nombreSolicitante)
  ) {
    return "";
  }

  return nombreGarante && nombreGarante !== "-" ? nombreGarante : "";
};

const nombreUsuarioSistema = (u = {}) => {
  if (!u || typeof u !== "object") return "";

  const nombreCompleto = [u.nombres, u.apellidos]
    .map(clean)
    .filter(Boolean)
    .join(" ")
    .replace(/\s+/g, " ")
    .trim();

  const nombreLegacy = [u.nombre, u.apellido]
    .map(clean)
    .filter(Boolean)
    .join(" ")
    .replace(/\s+/g, " ")
    .trim();

  return nombreCompleto || nombreLegacy || clean(u.email) || "";
};

const getUsuarioLogueadoTexto = () => {
  const token = localStorage.getItem("token") || "";

  try {
    if (!token) return "USUARIO SISTEMA";

    const decoded = jwt_decode(token);
    const usuario = decoded?.usuario || decoded?.user || decoded || {};

    return (
      nombreUsuarioSistema(usuario) ||
      clean(usuario.email) ||
      "USUARIO SISTEMA"
    );
  } catch {
    return "USUARIO SISTEMA";
  }
};

const nombreVendedorVenta = (venta = {}) => {
  return (
    clean(venta.vendedorNombre) ||
    clean(venta.usuarioNombre) ||
    nombreUsuarioSistema(venta.vendedor) ||
    nombreUsuarioSistema(venta.usuario) ||
    "-"
  );
};

const nombreColaboradorVenta = (venta = {}) => {
  return (
    clean(venta.colaboradorVentaNombre) ||
    nombreUsuarioSistema(venta.colaboradorVenta) ||
    "-"
  );
};

const productoItemTxt = (item = {}) => {
  return (
    clean(item.descripcionProducto) ||
    clean(item.modeloProducto) ||
    clean(item.producto?.nombreComercial) ||
    clean(item.producto?.modelo) ||
    "-"
  );
};

const clienteRecibeItemTxt = (item = {}) => {
  return nombreCliente(item.clienteRecibe);
};

const resumenProductos = (venta = {}) => {
  const items = Array.isArray(venta.items) ? venta.items : [];

  if (!items.length) return "-";

  return items
    .map((it) => {
      const prod = productoItemTxt(it);
      const cant = Number(it.cantidad || 0);

      return `${cant || 1} x ${prod}`;
    })
    .join(" | ");
};

const resumenClientesReciben = (venta = {}) => {
  const items = Array.isArray(venta.items) ? venta.items : [];

  if (!items.length) return "-";

  const set = new Set();

  items.forEach((it) => {
    const nombre = clienteRecibeItemTxt(it);
    if (nombre && nombre !== "-") set.add(nombre);
  });

  return Array.from(set).join(" | ") || "-";
};

const valorLegible = (valor) => {
  if (valor === null || valor === undefined) return "";

  if (typeof valor === "object") {
    return clean(
      valor.nombre ||
        valor.descripcion ||
        valor.provincia ||
        valor.municipio ||
        valor.zona ||
        valor.reparto ||
        valor.label ||
        valor.value
    );
  }

  return clean(valor);
};

const primerDato = (...valores) => {
  for (const valor of valores) {
    const texto = valorLegible(valor);
    if (texto) return texto;
  }

  return "";
};

const documentoClienteTxt = (cliente = {}) =>
  primerDato(
    cliente.dni,
    cliente.documento,
    cliente.carnetIdentidad,
    cliente.identificacion,
    cliente.idDocumento
  ) || "-";

const telefonoClienteTxt = (cliente = {}) =>
  primerDato(
    cliente.telefono1,
    cliente.telefonoPrincipal,
    cliente.telefono,
    cliente.celular,
    cliente.phone
  ) || "-";

const emailClienteTxt = (cliente = {}) =>
  primerDato(cliente.email, cliente.correo) || "-";

const provinciaClienteTxt = (cliente = {}) =>
  primerDato(cliente.provincia, cliente.estado) || "-";

const municipioClienteTxt = (cliente = {}) =>
  primerDato(cliente.municipio, cliente.ciudad) || "-";

const zonaClienteTxt = (cliente = {}) =>
  primerDato(
    cliente.zona,
    cliente.reparto,
    cliente.barrio
  ) || "-";

const direccionClienteTxt = (cliente = {}) => {
  const partes = [
    primerDato(
      cliente.direccion,
      cliente.domicilio,
      cliente.calle,
      cliente.address
    ),
    primerDato(cliente.ciudad),
    primerDato(cliente.estado),
    primerDato(
      cliente.codigoPostal,
      cliente.zipCode,
      cliente.zip
    ),
  ].filter(Boolean);

  return partes.join(", ") || "-";
};

const marcaProductoTxt = (item = {}) =>
  primerDato(
    item.producto?.marca?.marca,
    item.producto?.marca?.nombre,
    item.producto?.marca
  ) || "-";

const modeloProductoTxt = (item = {}) =>
  primerDato(
    item.modeloProducto,
    item.producto?.modelo
  ) || "-";

const colorProductoTxt = (item = {}) =>
  primerDato(
    item.colorNombre,
    item.producto?.colorNombre,
    item.producto?.color?.color,
    item.producto?.color?.nombre,
    item.producto?.color
  ) || "-";

const comprobantesLegibles = (venta = {}) => {
  const comprobantes = venta.comprobantes || {};
  const cargados = [];

  if (comprobantes.zelle?.url) {
    cargados.push("Zelle");
  }

  if (comprobantes.zelle1?.url) {
    cargados.push("Zelle adicional");
  }

  if (comprobantes.debitoCredito?.url) {
    cargados.push("Débito / Crédito");
  }

  return cargados.length
    ? cargados.join(" | ")
    : "Sin comprobantes";
};

const estadoClass = (estado) => `estado-${clean(estado || "PENDIENTE")}`;

const estadoPagoClass = (estado) =>
  `estadoPago-${clean(estado || "PENDIENTE")}`;

const getEstadoRecepcion = (venta = {}) => {
  return clean(venta.estadoRecepcion).toUpperCase() === "PENDIENTE"
    ? "PENDIENTE"
    : "COMPLETA";
};

const getSedeVenta = (venta = {}) => {
  const sede = clean(
    venta?.sede ||
    venta?.vendedor?.sede ||
    venta?.usuario?.sede ||
    ""
  )
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toUpperCase()
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  if (sede === "MIAMI") {
    return "MIAMI";
  }

  if (sede === "YERBA BUENA") {
    return "YERBA BUENA";
  }

  if (sede === "TUCUMAN") {
    return "TUCUMAN";
  }

  return "RESTO";
};

const sanitizeFileName = (v) =>
  clean(v)
    .replace(/[\\/:*?"<>|]+/g, "")
    .replace(/\s+/g, "_");

const getVentaFromResponse = (resp, fallback = null) => {
  if (resp?.venta) return resp.venta;
  if (resp?.data?.venta) return resp.data.venta;
  if (resp?.data) return resp.data;
  return resp || fallback;
};

function uniqById(arr) {
  const map = new Map();

  for (const it of arr || []) {
    const key = it?._id ?? it?.nroventa ?? JSON.stringify(it);
    if (!map.has(key)) map.set(key, it);
  }

  return Array.from(map.values());
}

function useDebounce(value, delay = 250) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);

  return debounced;
}

const loadImage = (src) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });

const fitImageInBox = (img, maxW, maxH) => {
  const w = img?.naturalWidth || img?.width || maxW;
  const h = img?.naturalHeight || img?.height || maxH;
  const ratio = Math.min(maxW / w, maxH / h);

  return {
    w: w * ratio,
    h: h * ratio,
  };
};

const btnActionSmall = {
  width: 28,
  height: 28,
  padding: 0,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: 4,
  fontSize: 13,
};

const estadoComprobantesVenta = (venta = {}) => {
  const c = venta.comprobantes || {};
  const tieneZelle = !!c.zelle?.url;
  const tieneDebitoCredito = !!c.debitoCredito?.url;

  if (tieneZelle && tieneDebitoCredito) return "full";
  if (tieneZelle || tieneDebitoCredito) return "partial";
  return "empty";
};

const tituloComprobantesVenta = (venta = {}) => {
  const c = venta.comprobantes || {};
  const tieneZelle = !!c.zelle?.url;
  const tieneDebitoCredito = !!c.debitoCredito?.url;

  if (tieneZelle && tieneDebitoCredito) {
    return "Comprobantes cargados: Zelle y Débito/Crédito";
  }

  if (tieneZelle) return "Comprobante cargado: Zelle";
  if (tieneDebitoCredito) return "Comprobante cargado: Débito/Crédito";

  return "Sin comprobantes cargados";
};

const normalizarTelefonoWhatsApp = (telefono = "") => {
  let n = String(telefono || "").replace(/\D/g, "");

  if (!n) return "";

  if (n.startsWith("00")) n = n.slice(2);
  if (n.startsWith("053")) n = n.slice(1);

  if (n.length === 8) {
    n = `53${n}`;
  }

  return n;
};

const datoWhatsApp = (v, fallback = "-") => {
  const t = String(v ?? "").trim();
  return t || fallback;
};

const nombreReceptorWhatsApp = (receptor = {}) => {
  return [receptor.nombre, receptor.segundoNombre]
    .map(clean)
    .filter(Boolean)
    .join(" ")
    .replace(/\s+/g, " ")
    .trim();
};

const productoColorWhatsApp = (producto = {}, item = {}) => {
  const nombre =
    clean(producto.nombreComercial) ||
    clean(producto.modelo) ||
    clean(producto.descripcion) ||
    clean(item.descripcionProducto) ||
    clean(item.modeloProducto) ||
    "-";

  const nombreColor = (color) => {
    if (!color || typeof color !== "object") return "";

    return (
      clean(color.nombre) ||
      clean(color.color) ||
      clean(color.descripcion) ||
      ""
    );
  };

  // 1. Si ya existe color entregado, tiene prioridad.
  const colorEntregado = nombreColor(
    item.colorEntregado
  );

  // 2. Si todavía no se entregó, usamos los colores preferidos.
  const coloresPreferidos = Array.isArray(
    item.coloresPreferidos
  )
    ? item.coloresPreferidos
        .map(nombreColor)
        .filter(Boolean)
    : [];

  // 3. Compatibilidad con registros anteriores.
  const colorLegacy =
    clean(item.colorNombre) ||
    clean(producto.colorNombre) ||
    nombreColor(producto.color);

  const color =
    colorEntregado ||
    coloresPreferidos.join(" / ") ||
    colorLegacy ||
    "";

  return color
    ? `${nombre} / ${color}`
    : nombre;
};

const colorFichaCubaWhatsApp = (item = {}) => {
  const producto = item.producto || {};

  const nombreColor = (color) => {
    if (!color) return "";

    if (typeof color === "string") {
      return clean(color);
    }

    if (typeof color === "object") {
      return (
        clean(color.nombre) ||
        clean(color.color) ||
        clean(color.descripcion) ||
        ""
      );
    }

    return "";
  };

  // Color entregado tiene prioridad
  const entregado = nombreColor(
    item.colorEntregado
  );

  if (entregado) {
    return entregado;
  }

  // Mientras no haya entregado, mostramos preferidos
  const preferidos = Array.isArray(
    item.coloresPreferidos
  )
    ? item.coloresPreferidos
        .map(nombreColor)
        .filter(Boolean)
    : [];

  if (preferidos.length) {
    return preferidos.join(" / ");
  }

  // Compatibilidad con ventas viejas
  return (
    clean(item.colorNombre) ||
    clean(producto.colorNombre) ||
    nombreColor(producto.color) ||
    "SIN DEFINIR"
  );
};

const direccionFichaCubaWhatsApp = (receptor = {}) => {
  const completa = clean(
    receptor.direccionCompleta
  );

  if (completa) {
    return completa;
  }

  return [
    clean(receptor.direccion),
    clean(receptor.referenciaDireccion),
  ]
    .filter(Boolean)
    .join(" - ") || "-";
};

const nombreReceptorFichaCuba = (receptor = {}) =>
  [
    clean(receptor.nombre),
    clean(receptor.segundoNombre),
  ]
    .filter(Boolean)
    .join(" ")
    .replace(/\s+/g, " ")
    .trim() || "-";

const linkWhatsApp = (titulo, url) => {
  const u = clean(url);
  if (!u) return "";
  return `${titulo}: ${u}`;
};

const armarLinksDocumentacionWhatsApp = (venta = {}, receptor = {}) => {
  const cliente = venta.clienteCompra || {};
  const comprobantes = venta.comprobantes || {};

  const lineas = [
    linkWhatsApp("ID comprador frente", cliente.documentos?.frente?.url),
    linkWhatsApp("ID comprador dorso", cliente.documentos?.dorso?.url),
    linkWhatsApp("ID comprador PDF", cliente.documentos?.pdf?.url),

    linkWhatsApp("ID receptor frente", receptor.documentos?.frente?.url),
    linkWhatsApp("ID receptor dorso", receptor.documentos?.dorso?.url),
    linkWhatsApp("ID receptor PDF", receptor.documentos?.pdf?.url),

    linkWhatsApp("Comprobante Zelle", comprobantes.zelle?.url),
    linkWhatsApp("Comprobante Zelle 2", comprobantes.zelle1?.url),
    linkWhatsApp("Comprobante Débito / Crédito", comprobantes.debitoCredito?.url),
  ].filter(Boolean);

  if (lineas.length === 0) return "";

  return `
Documentación / fotos:
${lineas.join("\n")}
`.trim();
};

const icono = (codigo) => String.fromCodePoint(codigo);

const EMOJI_FECHA = icono(128197);
const EMOJI_VENDEDOR = icono(128104);
const EMOJI_CLIENTE = icono(128100);
const EMOJI_TELEFONO = icono(128241);
const EMOJI_PRODUCTO = icono(128757);
const EMOJI_PAQUETE = icono(128230);
const EMOJI_PRECIO = icono(128181);
const EMOJI_TOTAL = icono(128176);
const EMOJI_FINANCIERA = icono(127974);
const EMOJI_GARANTE = icono(129309);

const EMOJI_PAGO = icono(128179);
const EMOJI_TAX = icono(129534);
const EMOJI_OK = icono(9989);

const emojiProductoWhatsApp = (item = {}) => {
  const producto = item.producto || {};

  const texto = normalizarNombreComparacion(
    [
      producto.grupoRecepcion,
      producto.tipoMotor,
      producto.categoria?.categoria,
      producto.categoria?.nombre,
      producto.categoria,
      producto.nombreComercial,
      producto.modelo,
      producto.descripcion,
      item.descripcionProducto,
      item.modeloProducto,
    ]
      .map(clean)
      .filter(Boolean)
      .join(" ")
  );

  if (
    texto.includes("MOTO") ||
    texto.includes("MOTOCICLETA") ||
    texto.includes("TRICICLO") ||
    texto.includes("SCOOTER") ||
    texto.includes("VEHICULO")
  ) {
    return EMOJI_PRODUCTO;
  }

  if (
    texto.includes("KIT") ||
    texto.includes("BATERIA") ||
    texto.includes("INVERSOR") ||
    texto.includes("PANEL") ||
    texto.includes("SOLAR") ||
    texto.includes("ENERGIA") ||
    texto.includes("CARGADOR")
  ) {
    return EMOJI_PAQUETE;
  }

  return EMOJI_PAQUETE;
};

const armarMensajeWhatsAppVenta = (venta = {}, receptorObjetivo = null) => {
  const cliente = venta.clienteCompra || {};
  const items = Array.isArray(venta.items) ? venta.items : [];

  const itemsDelReceptor = items;

  /* ---------------------------------------------------------
     RESUMEN FINANCIERO
  --------------------------------------------------------- */

  const resumenPagoWhatsApp = resumenFinanciero(
    venta,
    venta._resumenPagoWhatsApp || {}
  );

  const totalProductosUSD = Number(
    venta.totalProductosUSD || 0
  );

  const totalEnvioUSD = Number(
    venta.totalEnvioUSD || 0
  );

  const totalVentaUSD = Number(
    resumenPagoWhatsApp.totalVenta ??
      venta.totalUSD ??
      0
  );

  const totalAcreditadoUSD = Number(
    resumenPagoWhatsApp.totalAcreditadoUSD ??
      venta.totalAcreditadoUSD ??
      0
  );

  const saldoPendienteUSD = Number(
    resumenPagoWhatsApp.saldoPendienteUSD ??
      venta.saldoPendienteUSD ??
      Math.max(
        totalVentaUSD - totalAcreditadoUSD,
        0
      )
  );

  /*
    TAX REAL DE LA VENTA

    Total venta =
      Productos
      + Envío
      + Tax real

    De esta manera funciona también cuando hubo
    devolución de Tax por EFECTIVO EN TIENDA.
  */
  const taxVentaUSD =
    Math.round(
      Math.max(
        totalVentaUSD -
          totalProductosUSD -
          totalEnvioUSD,
        0
      ) * 100
    ) / 100;

  const taxPorcentaje = Number(
    venta.taxPorcentaje || 7
  );

  const mostrarTax =
    Boolean(venta.taxAplicado) ||
    taxVentaUSD > 0;

  /* ---------------------------------------------------------
     PAGOS
  --------------------------------------------------------- */

  const pagosWhatsApp = Array.isArray(
    venta._pagosWhatsApp
  )
    ? venta._pagosWhatsApp
    : [];

  /*
    Primer acompañante / garante real
    utilizado en los pagos de la venta.
  */

  const detallePagosTexto =
    pagosWhatsApp.length > 0
      ? pagosWhatsApp
          .map((pago) => {
            const medioPago = clean(
              pago.medioPago
            ).toUpperCase();

            const montoAplicadoUSD = Number(
              pago.montoUSD ||
                pago.montoFinancieraUSD ||
                0
            );

            /*
              CRÉDITO FINANCIERA
            */
            if (
              medioPago ===
              "CREDITO FINANCIERA"
            ) {
              const financiera =
                getNombreFinanciera(
                  pago.financiera
                );

              const feeMontoUSD = Number(
                pago.feeMontoUSD || 0
              );

              const feePorcentaje = Number(
                pago.feePorcentaje || 0
              );

              /*
                Si por algún registro anterior no existe
                totalCobrarClienteUSD, lo reconstruimos
                con monto aplicado + fee.
              */
              const totalCobrarGuardado = Number(
                pago.totalCobrarClienteUSD || 0
              );

              const totalCobradoClienteUSD =
                totalCobrarGuardado > 0
                  ? totalCobrarGuardado
                  : montoAplicadoUSD +
                    feeMontoUSD;

              const garanteTexto =
                nombreGaranteSiEsDistinto(
                  pago,
                  cliente
                );

              const garante =
                garanteTexto &&
                pago?.clienteFinanciacion &&
                typeof pago.clienteFinanciacion === "object"
                  ? pago.clienteFinanciacion
                  : null;

              const cuotas = Number(
                pago.cuotasFinanciacion || 0
              );

              return [
                `${EMOJI_PAGO} CREDITO FINANCIERA`,

                `${EMOJI_FINANCIERA} Financiera: ${datoWhatsApp(
                  financiera
                )}`,

                cuotas > 0
                  ? `📆 Cuotas: ${cuotas}`
                  : "",

                garanteTexto
                  ? `${EMOJI_GARANTE} Acomp./Garante: ${garanteTexto}`
                  : "",

                garanteTexto
                  ? `${EMOJI_TELEFONO} Cel Acomp./Garante: ${telefonoClienteTxt(
                      garante
                    )}`
                  : "",

                garanteTexto
                  ? `🪪 ID Acomp./Garante: ${documentoClienteTxt(
                      garante
                    )}`
                  : "",

                `${EMOJI_PRECIO} Aplicado a venta: ${formatUSD(
                  montoAplicadoUSD
                )}`,

                `${EMOJI_PRECIO} Fee Financiera${
                  feePorcentaje > 0
                    ? ` (${feePorcentaje}%)`
                    : ""
                }: ${formatUSD(
                  feeMontoUSD
                )}`,

                `${EMOJI_TOTAL} Total cobrado cliente: ${formatUSD(
                  totalCobradoClienteUSD
                )}`,
              ]
                .filter(Boolean)
                .join("\n");
            }

            /*
              OTROS MEDIOS:
              ZELLE
              EFECTIVO
              DÉBITO
              CRÉDITO
            */
            return [
              `${EMOJI_PAGO} ${datoWhatsApp(
                medioPago
              )}`,

              `${EMOJI_PRECIO} Monto: ${formatUSD(
                montoAplicadoUSD
              )}`,
            ].join("\n");
          })
          .join("\n\n")
      : "Sin pagos cargados.";

  /* ---------------------------------------------------------
    VENDEDOR / COLABORADOR DE LA VENTA
  --------------------------------------------------------- */

  const vendedorVenta =
    venta._vendedorTxt ||
    nombreVendedorVenta(venta) ||
    "-";

  const colaboradorVenta =
    venta._colaboradorTxt ||
    nombreColaboradorVenta(venta) ||
    "";

  /* ---------------------------------------------------------
     MENSAJE FINAL WHATSAPP
  --------------------------------------------------------- */

return `
🔢 Venta N°: ${datoWhatsApp(
    venta.nroventa
  )}
${EMOJI_FECHA} Fecha: ${datoWhatsApp(
    fmtDate(venta.fecha)
  )}
${EMOJI_VENDEDOR} Vendedor: ${datoWhatsApp(
    vendedorVenta
  )}
${
  colaboradorVenta &&
  colaboradorVenta !== "-"
    ? `${EMOJI_GARANTE} Colaborador: ${colaboradorVenta}`
    : ""
}
${EMOJI_CLIENTE} Cliente: ${datoWhatsApp(
    nombreCliente(cliente)
  )}
${EMOJI_TELEFONO} Cel Cliente: ${datoWhatsApp(
    telefonoClienteTxt(cliente)
  )}
🪪 ID Cliente: ${datoWhatsApp(
    documentoClienteTxt(cliente)
  )}
📍 Direcc Cliente: ${datoWhatsApp(
    direccionClienteTxt(cliente)
  )}

${
  itemsDelReceptor.length > 0
    ? itemsDelReceptor
        .map((item) => {
          const cantidad = Number(
            item.cantidad || 1
          );

          const producto =
            productoColorWhatsApp(
              item.producto,
              item
            );

          const importeItem = Number(
            item.subtotalUSD ||
              Number(
                item.precioVentaUSD || 0
              ) *
                cantidad ||
              0
          );

          return `${emojiProductoWhatsApp(
            item
          )} ${
            cantidad > 1
              ? `${cantidad} x `
              : ""
          }${producto}: ${formatUSD(
            importeItem
          )}`;
        })
        .join("\n")
    : "-"
}

${
  mostrarTax
    ? `${EMOJI_TAX} Tax (${taxPorcentaje}%): ${formatUSD(
        taxVentaUSD
      )}`
    : ""
}
${EMOJI_TOTAL} Total Venta: ${formatUSD(
    totalVentaUSD
  )}

${detallePagosTexto}

${EMOJI_OK} Total acreditado: ${formatUSD(
    totalAcreditadoUSD
  )}
${EMOJI_TOTAL} Saldo: ${formatUSD(
    saldoPendienteUSD
  )}
`.trim();
};

const armarMensajeWhatsAppFichaCuba = (venta = {}) => {
  const cliente = venta.clienteCompra || {};

  const items = Array.isArray(venta.items)
    ? venta.items
    : [];

  const detalleItems =
    items.length > 0
      ? items
          .map((item, index) => {
            const receptor =
              item.clienteRecibe || {};

            return [
              `${emojiProductoWhatsApp(item)} Producto ${index + 1}: ${productoItemTxt(item)}`,

              `🎨 Color: ${colorFichaCubaWhatsApp(item)}`,

              `👤 Nombre de quien recibe: ${nombreReceptorFichaCuba(
                receptor
              )}`,

              `👤 Apellido 1: ${datoWhatsApp(
                receptor.apellido1
              )}`,

              `👤 Apellido 2: ${datoWhatsApp(
                receptor.apellido2
              )}`,

              `🪪 Número de carnet: ${datoWhatsApp(
                receptor.carnetIdentidad
              )}`,

              `📱 Teléfono: ${datoWhatsApp(
                receptor.telefonoPrincipal ||
                  receptor.telefono1 ||
                  receptor.telefono
              )}`,

              `📍 Dirección: ${direccionFichaCubaWhatsApp(
                receptor
              )}`,

              `🏘️ Municipio: ${datoWhatsApp(
                receptor.municipio
              )}`,

              `🇨🇺 Provincia: ${datoWhatsApp(
                receptor.provincia
              )}`,
            ].join("\n");
          })
          .join("\n\n--------------------\n\n")
      : "Sin productos / receptor cargado.";

  return `
🇨🇺 FICHA CUBA

${EMOJI_CLIENTE} Cliente: ${datoWhatsApp(
    nombreCliente(cliente)
  )}
${EMOJI_TELEFONO} Cel Cliente: ${datoWhatsApp(
    cliente.telefono1 ||
      cliente.telefono ||
      cliente.telefonoPrincipal
  )}

${detalleItems}
`.trim();
};

const TELEFONOS_WHATSAPP_POR_SEDE = {
  TUCUMAN: "17863653986",
  MIAMI: "5491156441342",
  "YERBA BUENA": "13058075522",
};

const getTelefonoWhatsAppVenta = (venta = {}) => {
  const sede = getSedeVenta(venta);

  return (
    TELEFONOS_WHATSAPP_POR_SEDE[sede] ||
    ""
  );
};

const esDispositivoMovilWhatsApp = () => {
  const ua =
    navigator.userAgent ||
    navigator.vendor ||
    window.opera ||
    "";

  return /android|iphone|ipad|ipod/i.test(
    ua
  );
};

const crearUrlWhatsApp = (
  telefono,
  mensaje
) => {
  const texto =
    encodeURIComponent(
      mensaje
    );

  if (
    esDispositivoMovilWhatsApp()
  ) {
    // iPhone / Android
    return `https://wa.me/${telefono}?text=${texto}`;
  }

  // PC
  return `https://web.whatsapp.com/send?phone=${telefono}&text=${texto}`;
};


const abrirWhatsAppVenta = (
  venta = {},
  receptorObjetivo = null,
  ventanaDestino = null
) => {
  const items = Array.isArray(venta.items)
    ? venta.items
    : [];

  const receptor =
    receptorObjetivo ||
    items[0]?.clienteRecibe ||
    venta.clienteRecibe ||
    {};

  const sede = getSedeVenta(venta);

  const telefonoDestino =
    getTelefonoWhatsAppVenta(venta);

  const telefonoEmpresa =
    normalizarTelefonoWhatsApp(
      telefonoDestino
    );

  if (!telefonoEmpresa) {
    if (ventanaDestino) {
      ventanaDestino.close();
    }

    alert(
      `No hay un teléfono de WhatsApp configurado para la sede ${sede}.`
    );

    return "";
  }

  const mensaje =
    armarMensajeWhatsAppVenta(
      venta,
      receptor
    );

  const url =
    crearUrlWhatsApp(
      telefonoEmpresa,
      mensaje
    );

  if (ventanaDestino) {
    ventanaDestino.location.href = url;
  } else {
    window.location.href = url;
  }

  return telefonoEmpresa;
};

const abrirWhatsAppFichaCuba = (
  venta = {},
  ventanaDestino = null
) => {
  const sede = getSedeVenta(venta);

  const telefonoDestino =
    getTelefonoWhatsAppVenta(venta);

  const telefonoEmpresa =
    normalizarTelefonoWhatsApp(
      telefonoDestino
    );

  if (!telefonoEmpresa) {
    if (ventanaDestino) {
      ventanaDestino.close();
    }

    alert(
      `No hay un teléfono de WhatsApp configurado para la sede ${sede}.`
    );

    return false;
  }

  const mensaje =
    armarMensajeWhatsAppFichaCuba(
      venta
    );

  const url =
    crearUrlWhatsApp(
      telefonoEmpresa,
      mensaje
    );

  if (ventanaDestino) {
    ventanaDestino.location.href = url;
  } else {
    window.location.href = url;
  }

  return true;
};

export default function AppVentaReactTable() {
  const [all, setAll] = useState([]);
  const [loading, setLoading] = useState(true);

  const [exportando, setExportando] = useState("");

  const [q, setQ] = useState("");
  const dq = useDebounce(q, 250);

  const [recepcionFiltro, setRecepcionFiltro] = useState("");
  const [sedeFiltro, setSedeFiltro] = useState("");

  const [estadoFiltro, setEstadoFiltro] = useState("");

  const [desde, setDesde] = useState("");
  const [hasta, setHasta] = useState("");

  const [ventaSeguimiento, setVentaSeguimiento] = useState(null);

  const abrirSeguimientoCliente = useCallback((venta) => {
    if (!venta?.clienteCompra) {
      alert("Esta venta no tiene cliente comprador.");
      return;
    }

    setVentaSeguimiento(venta);
  }, []);

  const [progress, setProgress] = useState({
    loaded: 0,
    total: 0,
  });

  const [showFicha, setShowFicha] = useState(false);
  const [fichaData, setFichaData] = useState(null);
  const [fichaLoadingId, setFichaLoadingId] = useState(null);
  const [pdfLoadingId, setPdfLoadingId] = useState(null);
  const [estadoLoadingId, setEstadoLoadingId] = useState(null);

  const [showPago, setShowPago] = useState(false);
  const [ventaPago, setVentaPago] = useState(null);
  const [pagoLoadingId, setPagoLoadingId] = useState(null);

  const [showEditar, setShowEditar] = useState(false);
  const [ventaEditar, setVentaEditar] = useState(null);
  const [editLoadingId, setEditLoadingId] = useState(null);

  const [avisoEditar, setAvisoEditar] = useState({
    show: false,
    titulo: "",
    mensaje: "",
    tipo: "warning",
  });

  const [showComprobantes, setShowComprobantes] = useState(false);
  const [ventaComprobantes, setVentaComprobantes] = useState(null);

  const [showCompletarReceptor, setShowCompletarReceptor] =
  useState(false);

  const [ventaCompletarReceptor, setVentaCompletarReceptor] =
    useState(null);

  const [recepcionLoadingId, setRecepcionLoadingId] =
    useState(null);

  const seqRef = useRef(0);
  const abortRef = useRef(null);

  const enriquecerVenta = useCallback((v = {}) => {
    const totalUSD = Number(v.totalUSD || 0);
    const totalAcreditadoUSD = Number(v.totalAcreditadoUSD || 0);

    const saldoPendienteUSD = Math.max(totalUSD - totalAcreditadoUSD, 0);

    return {
      ...v,

      estadoPago: v.estadoPago || "PENDIENTE",
      totalPagadoUSD: Number(v.totalPagadoUSD || 0),
      totalAcreditadoUSD,
      saldoPendienteUSD,

      estadoRecepcion: getEstadoRecepcion(v),

      _fechaTxt: fmtDate(v.fecha),
      _clienteCompraTxt: nombreCliente(v.clienteCompra),
      _productosTxt: resumenProductos(v),
      _clientesRecibenTxt: resumenClientesReciben(v),
      _vendedorTxt: nombreVendedorVenta(v),
      _colaboradorTxt: nombreColaboradorVenta(v),
      _sedeVenta: getSedeVenta(v),
      _cantidadItems: Array.isArray(v.items) ? v.items.length : 0,
    };
  }, []);

  const fetchAll = useCallback(async () => {
    try {
      abortRef.current?.abort?.();
    } catch (_) {}

    const controller = new AbortController();
    abortRef.current = controller;

    const seq = ++seqRef.current;

    setLoading(true);
    setAll([]);
    setProgress({ loaded: 0, total: 0 });

    const LIMIT = 200;

    try {
      const first = await getVentas({
        page: 1,
        limit: LIMIT,
        q: "",
        estado: estadoFiltro,
        desde,
        hasta,
        signal: controller.signal,
      });

      if (seq !== seqRef.current) return;

      const total = Number(first?.total || 0);
      let acc = [...(first?.ventas || [])];

      acc = uniqById(acc);

      setAll(acc);
      setProgress({
        loaded: acc.length,
        total,
      });

      const pages = Math.max(1, Math.ceil(total / LIMIT));

      for (let p = 2; p <= pages; p++) {
        const r = await getVentas({
          page: p,
          limit: LIMIT,
          q: "",
          estado: estadoFiltro,
          desde,
          hasta,
          signal: controller.signal,
        });

        if (seq !== seqRef.current) return;

        acc = uniqById(acc.concat(r?.ventas || []));

        setAll(acc);
        setProgress({
          loaded: acc.length,
          total,
        });
      }
    } catch (e) {
      if (e?.name === "CanceledError" || e?.code === "ERR_CANCELED") return;

      console.error("❌ Error cargando ventas:", e);

      setAll([]);
      setProgress({
        loaded: 0,
        total: 0,
      });
    } finally {
      if (seq === seqRef.current) {
        setLoading(false);
      }
    }
  }, [estadoFiltro, desde, hasta]);

  useEffect(() => {
    fetchAll();

    return () => {
      try {
        abortRef.current?.abort?.();
      } catch (_) {}
    };
  }, [fetchAll]);

  const allEnriquecidas = useMemo(
    () => (all || []).map((v) => enriquecerVenta(v)),
    [all, enriquecerVenta]
  );

    const abrirPago = useCallback(
    async (ventaRow) => {
      if (!ventaRow?._id) {
        alert("No se encontró el ID de la venta.");
        return;
      }

      try {
        setPagoLoadingId(ventaRow._id);

        const resp = await getVentaById(ventaRow._id);
        const venta = getVentaFromResponse(resp, ventaRow);

        setVentaPago(enriquecerVenta(venta));
        setShowPago(true);
      } catch (e) {
        console.error("❌ Error abriendo pagos de venta:", e);

        // Si falla el detalle, abrimos igual con la fila del listado
        setVentaPago(enriquecerVenta(ventaRow));
        setShowPago(true);
      } finally {
        setPagoLoadingId(null);
      }
    },
    [enriquecerVenta]
  );

  const cerrarPago = useCallback(() => {
    setShowPago(false);
    setVentaPago(null);
  }, []);

  const onPagoSaved = useCallback(() => {
    fetchAll();
  }, [fetchAll]);

  const ventaTienePagos = (venta = {}) => {
  const estadoPago = clean(venta.estadoPago || "PENDIENTE").toUpperCase();

  return (
    Number(venta.totalPagadoUSD || 0) > 0 ||
    Number(venta.totalAcreditadoUSD || 0) > 0 ||
    estadoPago !== "PENDIENTE"
  );
};

const getPagosArray = (resp) => {
  if (Array.isArray(resp?.pagos)) return resp.pagos;
  if (Array.isArray(resp?.data?.pagos)) return resp.data.pagos;
  if (Array.isArray(resp)) return resp;
  return [];
};

const abrirEditar = useCallback(
  async (ventaRow) => {
    if (!ventaRow?._id) {
      alert("No se encontró el ID de la venta.");
      return;
    }

    if (ventaRow.estado === "ANULADA") {
      mostrarAvisoEditar(
        "No se puede editar una venta anulada.",
        "Venta anulada"
      );
      return;
    }

    /*
      Verificamos el rol nuevamente al momento
      de abrir la edición.
    */
    const rolActual = getRoleUsuario();
    const sedeActual = getSedeUsuario();

    const esAdminActual = [
      "ROOT_ROLE",
      "ADMIN_ROLE",
    ].includes(rolActual);

    const esManagerMiamiActual =
      rolActual === "MANAGER_ROLE" &&
      sedeActual === "MIAMI";

    const managerPuedeGestionarActual =
      esManagerMiamiActual &&
      esVentaMiamiPropia(ventaRow);

    /*
      Segunda barrera:
      un Manager Miami nunca puede editar
      una venta que no pertenezca a Miami.
    */
    if (
      esManagerMiamiActual &&
      !managerPuedeGestionarActual
    ) {
      mostrarAvisoEditar(
        "Esta venta pertenece a otra sede. El Manager Miami puede consultarla, pero no modificarla.",
        "Venta solo lectura"
      );

      return;
    }

    try {
      setEditLoadingId(ventaRow._id);

      const respPagos =
        await getPagosVenta(
          ventaRow._id
        );

      const pagos =
        getPagosArray(respPagos);

      /*
        Consideramos solamente pagos que
        realmente siguen activos.
      */
      const pagosActivos =
        pagos.filter(
          (pago) =>
            pago?.activo !== false &&
            clean(
              pago?.estadoAcreditacion
            ).toUpperCase() !==
              "ANULADO"
        );

      const tienePagos =
        pagosActivos.length > 0 ||
        ventaTienePagos(
          ventaRow
        );

      /*
        Si tiene pagos, solamente ADMIN / ROOT
        pueden continuar.
      */
      if (
        tienePagos &&
        !esAdminActual &&
        !managerPuedeGestionarActual
      ) {
        mostrarAvisoEditar(
          "Esta venta tiene pagos cargados. No tiene permisos para modificarla.",
          "Venta con pagos cargados"
        );

        return;
      }

      /*
        El administrador recibe una advertencia
        antes de entrar.

        El backend además protege producto,
        cantidad, precio, envío, comprador y TAX.
      */
      if (
        tienePagos &&
        (
          esAdminActual ||
          managerPuedeGestionarActual
        )
      ) {
      const continuar =
        window.confirm(
          "⚠️ ATENCIÓN\n" +
            "Esta venta tiene PAGOS CARGADOS.\n" +
            "Solo se permiten correcciones operativas.\n" +
            "Cliente, producto, cantidad, precio, envío y TAX no pueden modificarse.\n" +
            "¿Desea continuar?"
        );

              if (!continuar) {
                return;
              }
            }

      const respVenta =
        await getVentaById(
          ventaRow._id
        );

      const ventaDetalle =
        getVentaFromResponse(
          respVenta,
          ventaRow
        );

      setVentaEditar(
        enriquecerVenta({
          ...ventaDetalle,

          /*
            Lo dejamos marcado por si después
            queremos bloquear visualmente los
            campos económicos dentro del formulario.
          */
          _tienePagos: tienePagos,
        })
      );

      setShowEditar(true);
    } catch (e) {
      console.error(
        "❌ Error abriendo edición de venta:",
        e?.response?.data || e
      );

      alert(
        e?.response?.data?.error ||
          e?.response?.data?.message ||
          e?.message ||
          "No se pudo abrir la edición de la venta."
      );
    } finally {
      setEditLoadingId(null);
    }
  },
  [enriquecerVenta]
);

const cerrarEditar = useCallback(() => {
  setShowEditar(false);
  setVentaEditar(null);
}, []);

const abrirComprobantes = useCallback(
  async (ventaRow) => {
    if (!ventaRow?._id) {
      alert("No se encontró el ID de la venta.");
      return;
    }

    try {
      const resp = await getVentaById(ventaRow._id);
      const ventaDetalle = getVentaFromResponse(resp, ventaRow);

      setVentaComprobantes(enriquecerVenta(ventaDetalle));
      setShowComprobantes(true);
    } catch (e) {
      console.error("❌ Error abriendo comprobantes:", e);
      setVentaComprobantes(enriquecerVenta(ventaRow));
      setShowComprobantes(true);
    }
  },
  [enriquecerVenta]
);

const cerrarComprobantes = useCallback(() => {
  setShowComprobantes(false);
  setVentaComprobantes(null);
}, []);

const abrirCompletarReceptor = useCallback(
  async (ventaRow) => {
    if (!ventaRow?._id) {
      alert("No se encontró el ID de la venta.");
      return;
    }

    if (
      getEstadoRecepcion(ventaRow) !== "PENDIENTE"
    ) {
      alert(
        "La recepción de esta venta ya está completa."
      );
      return;
    }

    if (ventaRow.estado === "ANULADA") {
      alert(
        "No se puede completar el receptor de una venta anulada."
      );
      return;
    }

    const rolActual = getRoleUsuario();
    const sedeActual = getSedeUsuario();

    const esManagerMiamiActual =
      rolActual === "MANAGER_ROLE" &&
      sedeActual === "MIAMI";

    if (
      esManagerMiamiActual &&
      !esVentaMiamiPropia(ventaRow)
    ) {
      alert(
        "Esta venta pertenece a otra sede. El Manager Miami puede consultarla, pero no completar el receptor."
      );
      return;
    }

    try {
      setRecepcionLoadingId(
        ventaRow._id
      );

      /*
        Traemos nuevamente la venta porque necesitamos
        los ítems completos y sus _id reales.
      */
      const resp =
        await getVentaById(
          ventaRow._id
        );

      const ventaDetalle =
        getVentaFromResponse(
          resp,
          ventaRow
        );

      if (!ventaDetalle?._id) {
        throw new Error(
          "No se pudo obtener la venta."
        );
      }

      const ventaFinal =
        enriquecerVenta(
          ventaDetalle
        );

      setVentaCompletarReceptor(
        ventaFinal
      );

      setShowCompletarReceptor(
        true
      );
    } catch (e) {
      console.error(
        "❌ Error abriendo recepción pendiente:",
        e?.response?.data || e
      );

      alert(
        e?.response?.data?.error ||
          e?.response?.data?.message ||
          e?.message ||
          "No se pudo abrir la recepción pendiente."
      );
    } finally {
      setRecepcionLoadingId(
        null
      );
    }
  },
  [enriquecerVenta]
);

const cerrarCompletarReceptor =
  useCallback(() => {
    setShowCompletarReceptor(false);
    setVentaCompletarReceptor(null);
  }, []);

const onRecepcionGuardada =
  useCallback(
    (ventaActualizada) => {
      if (!ventaActualizada?._id) {
        return;
      }

      const ventaFinal =
        enriquecerVenta(
          ventaActualizada
        );

      /*
        Actualizamos solamente esta fila.
        No hace falta recargar toda la tabla.
      */
      setAll((prev) =>
        prev.map((v) =>
          v._id === ventaFinal._id
            ? ventaFinal
            : v
        )
      );
    },
    [enriquecerVenta]
  );

const onVentaComprobantesActualizada = useCallback(
  (ventaActualizada) => {
    if (!ventaActualizada?._id) return;

    const ventaFinal = enriquecerVenta(ventaActualizada);

    setVentaComprobantes(ventaFinal);

    setAll((prev) =>
      prev.map((v) => (v._id === ventaFinal._id ? ventaFinal : v))
    );
  },
  [enriquecerVenta]
);

const mostrarAvisoEditar = useCallback((mensaje, titulo = "Edición no permitida") => {
  setAvisoEditar({
    show: true,
    titulo,
    mensaje,
    tipo: "warning",
  });
}, []);

const cerrarAvisoEditar = useCallback(() => {
  setAvisoEditar({
    show: false,
    titulo: "",
    mensaje: "",
    tipo: "warning",
  });
}, []);

const onVentaEditada = useCallback(
  (ventaActualizada) => {
    if (ventaActualizada?._id) {
      const ventaFinal = enriquecerVenta(ventaActualizada);

      setAll((prev) =>
        prev.map((v) => (v._id === ventaFinal._id ? ventaFinal : v))
      );
    }

    fetchAll();
  },
  [enriquecerVenta, fetchAll]
);

  const dataFiltrada = useMemo(() => {
    const raw = clean(dq);

    let base = allEnriquecidas || [];

    if (sedeFiltro) {
      base = base.filter(
        (venta) =>
          getSedeVenta(venta) === sedeFiltro
      );
    }

    if (recepcionFiltro) {
      base = base.filter(
        (venta) =>
          getEstadoRecepcion(venta) === recepcionFiltro
      );
    }

    if (!raw) return base;

    const hasLetters = /[a-zA-ZáéíóúñüÁÉÍÓÚÑÜ]/.test(raw);
    const qText = norm(raw);
    const qNum = digits(raw);

    return base.filter((v) => {
      const nro = digits(v.nroventa);

      const texto = norm(
        [
          v._clienteCompraTxt,
          v._productosTxt,
          v._clientesRecibenTxt,
          v._vendedorTxt,
          v._colaboradorTxt,
          v.estado,
          v.estadoPago,
          v.observaciones,
        ].join(" ")
      );

      if (hasLetters) {
        return texto.includes(qText);
      }

      if (!qNum) return false;

      return nro.startsWith(qNum);
    });
  }, [allEnriquecidas, dq, recepcionFiltro, sedeFiltro,]);

  const totalesVista = useMemo(() => {
    return dataFiltrada.reduce(
      (acc, v) => {
        acc.productos += Number(v.totalProductosUSD || 0);
        acc.envio += Number(v.totalEnvioUSD || 0);
        acc.total += Number(v.totalUSD || 0);
        acc.acreditado += Number(v.totalAcreditadoUSD || 0);
        acc.saldo += Number(v.saldoPendienteUSD || 0);
        acc.comision += Number(v.totalComisionCalculadaUSD || 0);
        return acc;
      },
      {
        productos: 0,
        envio: 0,
        total: 0,
        acreditado: 0,
        saldo: 0,
        comision: 0,
      }
    );
  }, [dataFiltrada]);

  const cargarFichaData = useCallback(
    async (ventaRow) => {
      const ventaId = ventaRow?._id;

      const [respVenta, respPagos] = await Promise.all([
        getVentaById(ventaId),
        getPagosVenta(ventaId),
      ]);

      const ventaDetalle = getVentaFromResponse(respVenta, ventaRow) || {};
      const ventaPagos = respPagos?.venta || {};

      const colaboradorVenta =
        ventaDetalle.colaboradorVenta ||
        ventaRow?.colaboradorVenta ||
        ventaPagos.colaboradorVenta ||
        null;

      const colaboradorVentaNombre =
        ventaDetalle.colaboradorVentaNombre ||
        ventaRow?._colaboradorTxt ||
        ventaRow?.colaboradorVentaNombre ||
        ventaPagos.colaboradorVentaNombre ||
        "";

      const ventaFinal = {
        ...ventaRow,
        ...ventaDetalle,

        // De getPagosVenta tomamos SOLO datos financieros.
        // No pisamos clienteCompra ni items, porque ahí está clienteRecibe populado.
        estadoPago: ventaPagos.estadoPago ?? ventaDetalle.estadoPago ?? ventaRow.estadoPago,
        totalPagadoUSD:
          ventaPagos.totalPagadoUSD ??
          ventaDetalle.totalPagadoUSD ??
          ventaRow.totalPagadoUSD,
        totalAcreditadoUSD:
          ventaPagos.totalAcreditadoUSD ??
          ventaDetalle.totalAcreditadoUSD ??
          ventaRow.totalAcreditadoUSD,
        saldoPendienteUSD:
          ventaPagos.saldoPendienteUSD ??
          ventaDetalle.saldoPendienteUSD ??
          ventaRow.saldoPendienteUSD,

        // Aseguramos que los items sean los del detalle de venta.
        items:
          Array.isArray(ventaDetalle.items) && ventaDetalle.items.length > 0
            ? ventaDetalle.items
            : Array.isArray(ventaRow.items)
            ? ventaRow.items
            : [],

        clienteCompra:
          ventaDetalle.clienteCompra ||
          ventaRow.clienteCompra ||
          ventaPagos.clienteCompra,

        // Mantener siempre el colaborador de la venta original
        colaboradorVenta,
        colaboradorVentaNombre,
      };

      let seguimientosCliente = [];

      const clienteSeguimientoId = getId(ventaFinal.clienteCompra);

      if (clienteSeguimientoId) {
        try {
          const respSeg = await getSeguimientosClientes({
            clienteCompra: clienteSeguimientoId,
            activo: "true",
            limit: 5,
          });

          seguimientosCliente = Array.isArray(respSeg?.seguimientos)
            ? respSeg.seguimientos
            : [];
        } catch (e) {
          console.warn("No se pudieron cargar seguimientos del cliente:", e);
          seguimientosCliente = [];
        }
      }

      return {
        venta: enriquecerVenta(ventaFinal),
        pagos: Array.isArray(respPagos?.pagos) ? respPagos.pagos : [],
        resumenPago: respPagos?.resumenPago || null,
        seguimientosCliente,
        fechaEmision: new Date(),
      };
    },
    [enriquecerVenta]
  );

  const abrirFicha = useCallback(
    async (ventaRow) => {
      if (!ventaRow?._id) {
        alert("No se encontró el ID de la venta.");
        return;
      }

      try {
        setFichaLoadingId(ventaRow._id);
        setFichaData(null);
        setShowFicha(true);

        const data = await cargarFichaData(ventaRow);
        setFichaData(data);
      } catch (e) {
        console.error("❌ Error abriendo ficha de venta:", e);

        setFichaData({
          venta: enriquecerVenta(ventaRow),
          fechaEmision: new Date(),
        });
      } finally {
        setFichaLoadingId(null);
      }
    },
    [cargarFichaData, enriquecerVenta]
  );

  const anular = useCallback(
    async (ventaRow) => {
      if (!ventaRow?._id) {
        alert("No se encontró el ID de la venta.");
        return;
      }

      if (!window.confirm(`¿Anular la venta N° ${ventaRow.nroventa}?`)) return;

      const obs = window.prompt(
        "Observación de anulación:",
        "VENTA ANULADA DESDE LISTADO"
      );

      try {
        await anularVenta(ventaRow._id, obs || "VENTA ANULADA");
        fetchAll();
      } catch (e) {
        console.error("❌ Error anularVenta:", e?.response?.data || e);

        alert(
          e?.response?.data?.error ||
            e?.response?.data?.message ||
            e?.message ||
            "No se pudo anular la venta."
        );
      }
    },
    [fetchAll]
  );

  const cambiarEstado = useCallback(
    async (ventaRow, estado) => {
      if (!ventaRow?._id) return;

      try {
        setEstadoLoadingId(ventaRow._id);

        await cambiarEstadoVenta(ventaRow._id, estado);

        setAll((prev) =>
          prev.map((v) =>
            v._id === ventaRow._id
              ? {
                  ...v,
                  estado,
                }
              : v
          )
        );
      } catch (e) {
        console.error("❌ Error cambiarEstadoVenta:", e?.response?.data || e);

        alert(
          e?.response?.data?.error ||
            e?.response?.data?.message ||
            e?.message ||
            "No se pudo cambiar el estado."
        );
      } finally {
        setEstadoLoadingId(null);
      }
    },
    []
  );

  const generarPdfVenta = useCallback(
    async (ventaRow) => {
      if (!ventaRow?._id) return;

      try {
        setPdfLoadingId(ventaRow._id);

        const data = await cargarFichaData(ventaRow);
        const venta = data.venta;
        const pagos = Array.isArray(data.pagos) ? data.pagos : [];
        const resumenPago = resumenFinanciero(venta, data.resumenPago); 

        const doc = new jsPDF({
          orientation: "p",
          unit: "mm",
          format: "a4",
        });

        const pageWidth = doc.internal.pageSize.getWidth();

        try {
          const logo = await loadImage(ridersLogo);
          const box = fitImageInBox(logo, 38, 22);
          doc.addImage(logo, "PNG", 10, 7, box.w, box.h);
        } catch (e) {
          console.warn("No se pudo cargar logo:", e);
        }

        doc.setFont("times", "bold");
        doc.setFontSize(20);
        doc.text("FICHA DE VENTA", pageWidth / 2, 16, {
          align: "center",
        });

        doc.setFont("helvetica", "bold");
        doc.setFontSize(12);
        doc.text(`N°: ${textOrDash(venta.nroventa)}`, 190, 16, {
          align: "right",
        });

        doc.setFont("helvetica", "normal");
        doc.setFontSize(9);
        doc.text(`Fecha emisión: ${fmtDate(new Date())}`, 190, 22, {
          align: "right",
        });

        doc.setDrawColor(60);
        doc.line(10, 30, 200, 30);

        autoTable(doc, {
          startY: 34,
          theme: "grid",
          styles: {
            fontSize: 8.5,
            cellPadding: 2,
            valign: "middle",
            overflow: "linebreak",
          },
          columnStyles: {
            0: { cellWidth: 38, fontStyle: "bold" },
            1: { cellWidth: 58 },
            2: { cellWidth: 38, fontStyle: "bold" },
            3: { cellWidth: 56 },
          },
          body: [
            ["N° Venta", textOrDash(venta.nroventa), "Fecha", fmtDate(venta.fecha)],
            [
              "Cliente compra",
              textOrDash(venta._clienteCompraTxt),
              "Estado",
              textOrDash(venta.estado),
            ],
            [
              "Colaborador",
              textOrDash(venta._colaboradorTxt),
              "Vendedor",
              textOrDash(venta._vendedorTxt),
            ],
            [
              "Total productos",
              formatUSD(venta.totalProductosUSD),
              "Total envío",
              formatUSD(venta.totalEnvioUSD),
            ],
            [
              "Total venta",
              formatUSD(venta.totalUSD),
              "Comisión",
              formatUSD(venta.totalComisionCalculadaUSD),
            ],
            [
              "Precios bajo mínimo",
              venta.tienePreciosBajoMinimo ? "Sí" : "No",
              "Observaciones",
              textOrDash(venta.observaciones),
            ],
          ],
        });

        const items = Array.isArray(venta.items) ? venta.items : [];

        autoTable(doc, {
          startY: doc.lastAutoTable.finalY + 6,
          theme: "grid",
          head: [
            [
              "#",
              "Producto",
              "Cliente recibe",
              "Cant.",
              "Precio",
              "Envío",
              "Subtotal",
              "Estado",
            ],
          ],
          body: items.map((it, idx) => [
            idx + 1,
            productoItemTxt(it),
            clienteRecibeItemTxt(it),
            Number(it.cantidad || 0),
            formatUSD(it.precioVentaUSD),
            formatUSD(it.costoEnvioUSD),
            formatUSD(it.subtotalUSD),
            textOrDash(it.estadoItem),
          ]),
          styles: {
            fontSize: 7.8,
            cellPadding: 1.8,
            overflow: "linebreak",
          },
          headStyles: {
            fillColor: [47, 111, 228],
          },
          columnStyles: {
            0: { cellWidth: 8, halign: "center" },
            1: { cellWidth: 42 },
            2: { cellWidth: 42 },
            3: { cellWidth: 12, halign: "right" },
            4: { cellWidth: 22, halign: "right" },
            5: { cellWidth: 22, halign: "right" },
            6: { cellWidth: 24, halign: "right" },
            7: { cellWidth: 22 },
          },
        });


        autoTable(doc, {
          startY: doc.lastAutoTable.finalY + 6,
          theme: "grid",
          styles: {
            fontSize: 8,
            cellPadding: 1.8,
            overflow: "linebreak",
          },
          headStyles: {
            fillColor: [60, 60, 60],
          },
          head: [["INFORMACIÓN FINANCIERA", "", "", ""]],
          body: [
            [
              "Estado pago",
              resumenPago.estadoPago,
              "Total venta",
              formatUSD(resumenPago.totalVenta),
            ],
            [
              "Total cargado",
              formatUSD(resumenPago.totalPagadoUSD),
              "Total acreditado",
              formatUSD(resumenPago.totalAcreditadoUSD),
            ],
            [
              "Saldo pendiente",
              formatUSD(resumenPago.saldoPendienteUSD),
              "Pagos cargados",
              String(pagos.length),
            ],
          ],
          columnStyles: {
            0: { cellWidth: 38, fontStyle: "bold" },
            1: { cellWidth: 55 },
            2: { cellWidth: 38, fontStyle: "bold" },
            3: { cellWidth: 55 },
          },
        });

        autoTable(doc, {
          startY: doc.lastAutoTable.finalY + 5,
          theme: "grid",
          head: [
            [
              "N°",
              "Fecha",
              "Medio",
              "Financ.",
              "Acomp./Garante",
              "Monto",
              "Estado",
              "Acredit.",
              "Firm.",
            ],
          ],
          body:
            pagos.length === 0
              ? [["-", "-", "Sin pagos cargados", "-", "-", "-", "-", "-", "-"]]
              : pagos.map((pago) => [
                  textOrDash(pago.nropago),
                  fmtDate(pago.fechaPago),
                  textOrDash(pago.medioPago),
                  getNombreFinanciera(pago.financiera),
                  nombreClienteFinanciacionPago(pago, venta.clienteCompra),
                  formatUSD(pago.montoUSD),
                  textOrDash(pago.estadoAcreditacion),
                  fmtDate(pago.fechaAcreditacion),
                  firmadoPagoTxt(pago),
                ]),
          styles: {
            fontSize: 6.8,
            cellPadding: 1.3,
            overflow: "linebreak",
            valign: "middle",
          },
          headStyles: {
            fillColor: [47, 111, 228],
            textColor: 255,
            fontStyle: "bold",
            fontSize: 6.8,
            halign: "center",
          },
          columnStyles: {
            0: { cellWidth: 8, halign: "center" },   // N°
            1: { cellWidth: 16, halign: "center" },  // Fecha
            2: { cellWidth: 24 },                    // Medio
            3: { cellWidth: 20 },                    // Financiera
            4: { cellWidth: 35 },                    // Acomp./Garante
            5: { cellWidth: 20, halign: "right" },   // Monto
            6: { cellWidth: 18 },                    // Estado
            7: { cellWidth: 17, halign: "center" },  // Acreditación
            8: { cellWidth: 14, halign: "center" },  // Firmado
          },
        });

        doc.save(
          `Venta_${textOrDash(venta.nroventa)}_${sanitizeFileName(
            venta._clienteCompraTxt
          )}.pdf`
        );
      } catch (e) {
        console.error("❌ Error generando PDF:", e);
        alert("No se pudo generar el PDF de la venta.");
      } finally {
        setPdfLoadingId(null);
      }
    },
    [cargarFichaData]
  );

  const exportarExcelVentas = useCallback(
    async (
      rowsOriginales,
      tipo = "vista"
    ) => {
      const rows =
        filtrarVentasParaExportacion(
          rowsOriginales
        );

      if (!rows.length) {
        alert(
          "No hay ventas para exportar."
        );
        return;
      }

      try {
        setExportando(`excel-${tipo}`);

        const detalles = [];
        const TAMANO_LOTE = 6;

        // Se procesan en lotes para no disparar cientos
        // de solicitudes simultáneamente.
        for (
          let indice = 0;
          indice < rows.length;
          indice += TAMANO_LOTE
        ) {
          const lote = rows.slice(
            indice,
            indice + TAMANO_LOTE
          );

          const resultadoLote = await Promise.all(
            lote.map(async (ventaRow) => {
              try {
                const [respVenta, respPagos] =
                  await Promise.all([
                    getVentaById(ventaRow._id),
                    getPagosVenta(ventaRow._id),
                  ]);

                const ventaDetalle =
                  getVentaFromResponse(
                    respVenta,
                    ventaRow
                  ) || {};

                const ventaPagos =
                  respPagos?.venta || {};

                const ventaFinal = enriquecerVenta({
                  ...ventaRow,
                  ...ventaDetalle,

                  estadoPago:
                    ventaPagos.estadoPago ??
                    ventaDetalle.estadoPago ??
                    ventaRow.estadoPago,

                  totalPagadoUSD:
                    ventaPagos.totalPagadoUSD ??
                    ventaDetalle.totalPagadoUSD ??
                    ventaRow.totalPagadoUSD,

                  totalAcreditadoUSD:
                    ventaPagos.totalAcreditadoUSD ??
                    ventaDetalle.totalAcreditadoUSD ??
                    ventaRow.totalAcreditadoUSD,

                  saldoPendienteUSD:
                    ventaPagos.saldoPendienteUSD ??
                    ventaDetalle.saldoPendienteUSD ??
                    ventaRow.saldoPendienteUSD,
                });

                return {
                  venta: ventaFinal,
                  pagos: getPagosArray(respPagos),
                  resumenPago:
                    respPagos?.resumenPago || null,
                };
              } catch (errorVenta) {
                console.warn(
                  "No se pudo ampliar una venta:",
                  ventaRow.nroventa,
                  errorVenta
                );

                return {
                  venta: enriquecerVenta(ventaRow),
                  pagos: [],
                  resumenPago: null,
                };
              }
            })
          );

          detalles.push(...resultadoLote);
        }

        const filasVentas = [];
        const filasProductos = [];
        const filasPagos = [];

        detalles.forEach((detalle) => {
          const venta = detalle.venta || {};
          const cliente = venta.clienteCompra || {};
          const items = Array.isArray(venta.items)
            ? venta.items
            : [];

          const pagos = Array.isArray(detalle.pagos)
            ? detalle.pagos
            : [];

          const resumen = resumenFinanciero(
            venta,
            detalle.resumenPago
          );

          const cantidadProductos = items.reduce(
            (total, item) =>
              total + Number(item.cantidad || 0),
            0
          );

          filasVentas.push({
            "N° Venta": venta.nroventa || "",
            Fecha: fmtDate(venta.fecha),
            "Estado venta": venta.estado || "PENDIENTE",

            "Cliente comprador": nombreCliente(cliente),
            "Documento comprador":
              documentoClienteTxt(cliente),
            "Teléfono comprador":
              telefonoClienteTxt(cliente),
            "Email comprador": emailClienteTxt(cliente),
            "Dirección comprador":
              direccionClienteTxt(cliente),

            Productos: resumenProductos(venta),
            "Clientes receptores":
              resumenClientesReciben(venta),
            "Cantidad productos": cantidadProductos,

            "Estado pago": resumen.estadoPago,
            "Total productos USD": Number(
              venta.totalProductosUSD || 0
            ),
            "Envío USD": Number(
              venta.totalEnvioUSD || 0
            ),
            "Total venta USD": Number(
              resumen.totalVenta || 0
            ),
            "Total cargado USD": Number(
              resumen.totalPagadoUSD || 0
            ),
            "Total acreditado USD": Number(
              resumen.totalAcreditadoUSD || 0
            ),
            "Saldo pendiente USD": Number(
              resumen.saldoPendienteUSD || 0
            ),
            "Comisión USD": Number(
              venta.totalComisionCalculadaUSD || 0
            ),

            "Bajo precio mínimo":
              venta.tienePreciosBajoMinimo
                ? "Sí"
                : "No",

            "Comprobantes cargados":
              comprobantesLegibles(venta),

            Vendedor:
              venta._vendedorTxt ||
              nombreVendedorVenta(venta),

            Colaborador:
              venta._colaboradorTxt ||
              nombreColaboradorVenta(venta),

            Observaciones:
              venta.observaciones || "",
          });

          items.forEach((item) => {
            const receptor =
              item.clienteRecibe || {};

            filasProductos.push({
              "N° Venta": venta.nroventa || "",
              Fecha: fmtDate(venta.fecha),

              "Cliente comprador":
                nombreCliente(cliente),

              Producto: productoItemTxt(item),
              Marca: marcaProductoTxt(item),
              Modelo: modeloProductoTxt(item),
              Color: colorProductoTxt(item),

              Cantidad: Number(
                item.cantidad || 0
              ),

              "Precio unitario USD": Number(
                item.precioVentaUSD || 0
              ),

              "Envío USD": Number(
                item.costoEnvioUSD || 0
              ),

              "Subtotal USD": Number(
                item.subtotalUSD || 0
              ),

              "Estado producto":
                item.estadoItem || "-",

              Track:
                primerDato(
                  item.track,
                  item.tracking,
                  venta.track
                ) || "-",

              "Cliente receptor":
                nombreCliente(receptor),

              "Carnet receptor":
                documentoClienteTxt(receptor),

              "Teléfono receptor":
                telefonoClienteTxt(receptor),

              Provincia:
                provinciaClienteTxt(receptor),

              Municipio:
                municipioClienteTxt(receptor),

              "Zona / reparto":
                zonaClienteTxt(receptor),

              "Dirección receptor":
                direccionClienteTxt(receptor),
            });
          });

          pagos.forEach((pago) => {
            filasPagos.push({
              "N° Venta": venta.nroventa || "",
              "N° Pago": pago.nropago || "",
              "Fecha pago": fmtDate(
                pago.fechaPago
              ),

              "Cliente comprador":
                nombreCliente(cliente),

              "Medio de pago":
                pago.medioPago || "-",

              Financiera:
                getNombreFinanciera(
                  pago.financiera
                ),

              "Acompañante / garante":
                nombreClienteFinanciacionPago(
                  pago,
                  cliente
                ),

              "Monto USD": Number(
                pago.montoUSD || 0
              ),

              "Estado acreditación":
                pago.estadoAcreditacion || "-",

              "Fecha acreditación":
                fmtDate(
                  pago.fechaAcreditacion
                ),

              "Contrato firmado":
                firmadoPagoTxt(pago),

              Observaciones:
                pago.observaciones || "",
            });
          });
        });

        const libro = XLSX.utils.book_new();

        const agregarHoja = (
          nombre,
          filas,
          anchos = []
        ) => {
          let hoja;

          if (filas.length) {
            hoja =
              XLSX.utils.json_to_sheet(filas);
          } else {
            hoja =
              XLSX.utils.aoa_to_sheet([
                ["Sin registros"],
              ]);
          }

          if (anchos.length) {
            hoja["!cols"] = anchos.map(
              (ancho) => ({ wch: ancho })
            );
          }

          XLSX.utils.book_append_sheet(
            libro,
            hoja,
            nombre
          );
        };

        agregarHoja(
          "Ventas",
          filasVentas,
          [
            12, 12, 18, 30, 20, 20, 30, 40,
            60, 45, 15, 18, 18, 15, 18, 18,
            20, 20, 16, 18, 30, 25, 25, 45,
          ]
        );

        agregarHoja(
          "Productos y receptores",
          filasProductos,
          [
            12, 12, 30, 35, 18, 20, 18, 12,
            18, 15, 18, 18, 18, 35, 20, 20,
            20, 20, 25, 45,
          ]
        );

        agregarHoja(
          "Pagos",
          filasPagos,
          [
            12, 12, 14, 30, 25, 25, 35,
            16, 22, 18, 18, 45,
          ]
        );

        const fechaArchivo = new Date()
          .toISOString()
          .slice(0, 10);

        XLSX.writeFile(
          libro,
          `ventas_${tipo}_${fechaArchivo}.xlsx`
        );
      } catch (errorExportacion) {
        console.error(
          "Error exportando ventas:",
          errorExportacion
        );

        alert(
          "No se pudo generar el archivo Excel."
        );
      } finally {
        setExportando("");
      }
    },
    [enriquecerVenta]
  );

  const exportarPdfListado = useCallback(
    (
      rowsOriginales,
      tipo = "vista"
    ) => {
      const rows =
        filtrarVentasParaExportacion(
          rowsOriginales
        );

      if (!rows.length) {
        alert(
          "No hay ventas para exportar."
        );
        return;
      }
      
    try {
      setExportando(`pdf-${tipo}`);

      const doc = new jsPDF({
        orientation: "l",
        unit: "mm",
        format: "a4",
      });

      const agregarEncabezado = (
        titulo,
        numeroPagina
      ) => {
        doc.setFont("helvetica", "bold");
        doc.setFontSize(15);

        doc.text(
          titulo,
          148,
          12,
          { align: "center" }
        );

        doc.setFont("helvetica", "normal");
        doc.setFontSize(8);

        doc.text(
          `Generado: ${fmtDate(new Date())}`,
          10,
          18
        );

        doc.text(
          `Registros: ${rows.length}`,
          148,
          18,
          { align: "center" }
        );

        doc.text(
          `Página ${numeroPagina}`,
          287,
          18,
          { align: "right" }
        );
      };

      agregarEncabezado(
        "LISTADO OPERATIVO DE VENTAS",
        1
      );

      autoTable(doc, {
        startY: 22,

        head: [[
          "N°",
          "Fecha",
          "Cliente comprador",
          "Teléfono",
          "Cliente receptor",
          "Productos",
          "Estado",
          "Vendedor",
        ]],

        body: rows.map((venta) => [
          textOrDash(venta.nroventa),
          fmtDate(venta.fecha),

          textOrDash(
            venta._clienteCompraTxt
          ),

          telefonoClienteTxt(
            venta.clienteCompra || {}
          ),

          textOrDash(
            venta._clientesRecibenTxt
          ),

          textOrDash(
            venta._productosTxt
          ),

          textOrDash(venta.estado),

          textOrDash(
            venta._vendedorTxt
          ),
        ]),

        theme: "grid",

        styles: {
          fontSize: 6.5,
          cellPadding: 1.5,
          overflow: "linebreak",
          valign: "middle",
        },

        headStyles: {
          fillColor: [47, 111, 228],
          textColor: 255,
          fontStyle: "bold",
          halign: "center",
        },

        alternateRowStyles: {
          fillColor: [245, 247, 250],
        },

        columnStyles: {
          0: {
            cellWidth: 14,
            halign: "center",
          },
          1: {
            cellWidth: 20,
            halign: "center",
          },
          2: { cellWidth: 48 },
          3: { cellWidth: 27 },
          4: { cellWidth: 48 },
          5: { cellWidth: 72 },
          6: { cellWidth: 25 },
          7: { cellWidth: 28 },
        },
      });

      doc.addPage();

      agregarEncabezado(
        "RESUMEN FINANCIERO DE VENTAS",
        2
      );

      autoTable(doc, {
        startY: 22,

        head: [[
          "N°",
          "Fecha",
          "Cliente comprador",
          "Estado pago",
          "Productos USD",
          "Envío USD",
          "Total USD",
          "Acreditado USD",
          "Saldo USD",
          "Comisión USD",
        ]],

        body: rows.map((venta) => [
          textOrDash(venta.nroventa),
          fmtDate(venta.fecha),

          textOrDash(
            venta._clienteCompraTxt
          ),

          textOrDash(
            venta.estadoPago
          ),

          formatUSD(
            venta.totalProductosUSD
          ),

          formatUSD(
            venta.totalEnvioUSD
          ),

          formatUSD(
            venta.totalUSD
          ),

          formatUSD(
            venta.totalAcreditadoUSD
          ),

          formatUSD(
            venta.saldoPendienteUSD
          ),

          formatUSD(
            venta.totalComisionCalculadaUSD
          ),
        ]),

        foot: [[
          "TOTALES",
          "",
          "",
          "",

          formatUSD(
            rows.reduce(
              (total, venta) =>
                total +
                Number(
                  venta.totalProductosUSD ||
                    0
                ),
              0
            )
          ),

          formatUSD(
            rows.reduce(
              (total, venta) =>
                total +
                Number(
                  venta.totalEnvioUSD || 0
                ),
              0
            )
          ),

          formatUSD(
            rows.reduce(
              (total, venta) =>
                total +
                Number(
                  venta.totalUSD || 0
                ),
              0
            )
          ),

          formatUSD(
            rows.reduce(
              (total, venta) =>
                total +
                Number(
                  venta.totalAcreditadoUSD ||
                    0
                ),
              0
            )
          ),

          formatUSD(
            rows.reduce(
              (total, venta) =>
                total +
                Number(
                  venta.saldoPendienteUSD ||
                    0
                ),
              0
            )
          ),

          formatUSD(
            rows.reduce(
              (total, venta) =>
                total +
                Number(
                  venta.totalComisionCalculadaUSD ||
                    0
                ),
              0
            )
          ),
        ]],

        theme: "grid",

        styles: {
          fontSize: 6.5,
          cellPadding: 1.5,
          overflow: "linebreak",
          valign: "middle",
        },

        headStyles: {
          fillColor: [47, 111, 228],
          textColor: 255,
          fontStyle: "bold",
          halign: "center",
        },

        footStyles: {
          fillColor: [235, 235, 235],
          textColor: 20,
          fontStyle: "bold",
        },

        columnStyles: {
          0: {
            cellWidth: 13,
            halign: "center",
          },
          1: {
            cellWidth: 20,
            halign: "center",
          },
          2: { cellWidth: 48 },
          3: { cellWidth: 25 },
          4: {
            cellWidth: 27,
            halign: "right",
          },
          5: {
            cellWidth: 24,
            halign: "right",
          },
          6: {
            cellWidth: 27,
            halign: "right",
          },
          7: {
            cellWidth: 29,
            halign: "right",
          },
          8: {
            cellWidth: 27,
            halign: "right",
          },
          9: {
            cellWidth: 27,
            halign: "right",
          },
        },
      });

      const fechaArchivo = new Date()
        .toISOString()
        .slice(0, 10);

      doc.save(
        `ventas_${tipo}_${fechaArchivo}.pdf`
      );
    } catch (errorPdf) {
      console.error(
        "Error generando PDF:",
        errorPdf
      );

      alert(
        "No se pudo generar el PDF."
      );
    } finally {
      setExportando("");
    }
  },
  []
);

  
  const role = getRoleUsuario();
  const sedeUsuario = getSedeUsuario();

  const esAdmin = [
    "ROOT_ROLE",
    "ADMIN_ROLE",
  ].includes(role);

  const esManagerMiami =
    role === "MANAGER_ROLE" &&
    sedeUsuario === "MIAMI";

  const enviarWhatsAppDesdeListado = useCallback(
    async (ventaRow) => {
      if (!ventaRow?._id) {
        alert("No se encontró el ID de la venta.");
        return;
      }

      if (
        esManagerMiami &&
        !esVentaMiamiPropia(ventaRow)
      ) {
        alert(
          "Esta venta pertenece a otra sede. El Manager Miami puede consultarla, pero no enviar ni registrar el aviso por WhatsApp."
        );
        return;
      }

      /*
        La ventana se abre inmediatamente después de las validaciones,
        todavía dentro del click del usuario.
        Esto es importante para Safari en iPhone/iPad.
      */
      const ventanaWhatsApp = window.open(
        "",
        "_blank"
      );

      try {
        const [respVenta, respPagos] = await Promise.all([
          getVentaById(ventaRow._id),
          getPagosVenta(ventaRow._id),
        ]);

        const ventaDetalle = getVentaFromResponse(respVenta, ventaRow) || {};
        const pagos = getPagosArray(respPagos);
        const resumenPago = respPagos?.resumenPago || null;
        const ventaPagos = respPagos?.venta || {};

        const ventaPreparada = enriquecerVenta({
          ...ventaDetalle,

          // Solo tomamos datos financieros de la respuesta de pagos.
          // No pisamos clienteCompra ni items porque ahí vienen los documentos y receptor completos.
          estadoPago: ventaPagos.estadoPago || ventaDetalle.estadoPago,
          totalPagadoUSD:
            ventaPagos.totalPagadoUSD ?? ventaDetalle.totalPagadoUSD,
          totalAcreditadoUSD:
            ventaPagos.totalAcreditadoUSD ?? ventaDetalle.totalAcreditadoUSD,
          saldoPendienteUSD:
            ventaPagos.saldoPendienteUSD ?? ventaDetalle.saldoPendienteUSD,

          _pagosWhatsApp: pagos,
          _resumenPagoWhatsApp: resumenPago,
        });

        // 1. Abrimos WhatsApp según la sede del vendedor
        const telefonoDestino =
          abrirWhatsAppVenta(
            ventaPreparada,
            null,
            ventanaWhatsApp
          );

        if (!telefonoDestino) {
          return;
        }

        // 2. Marcamos en backend el número real utilizado
        await marcarWhatsappVenta(
          ventaRow._id,
          {
            telefonoDestino,
          }
        );

        // 3. Refresco automático para que cambie el color sin romper la grilla
        setTimeout(() => {
          window.location.reload();
        }, 800);
      } catch (e) {
        console.error("❌ Error preparando WhatsApp:", e);

        if (
          ventanaWhatsApp &&
          !ventanaWhatsApp.closed
        ) {
          ventanaWhatsApp.close();
        }

        alert(
          e?.response?.data?.error ||
            e?.response?.data?.message ||
            e?.message ||
            "No se pudo preparar o marcar el WhatsApp."
        );
      }
    },
    [enriquecerVenta, esManagerMiami]
    );

  const enviarFichaCubaDesdeListado = useCallback(
  async (ventaRow) => {
    if (!ventaRow?._id) {
      alert(
        "No se encontró el ID de la venta."
      );
      return;
    }

    if (
      esManagerMiami &&
      !esVentaMiamiPropia(ventaRow)
    ) {
      alert(
        "Esta venta pertenece a otra sede. El Manager Miami puede consultarla, pero no enviar la Ficha Cuba."
      );
      return;
    }

    if (
      getEstadoRecepcion(ventaRow) ===
      "PENDIENTE"
    ) {
      alert(
        "La venta todavía no tiene completos los datos del receptor en Cuba."
      );
      return;
    }

    const ventanaWhatsApp =
      window.open(
        "",
        "_blank"
      );

    try {
      const respVenta =
        await getVentaById(
          ventaRow._id
        );

      const ventaDetalle =
        getVentaFromResponse(
          respVenta,
          ventaRow
        ) || {};

      const ventaPreparada =
        enriquecerVenta(
          ventaDetalle
        );

      abrirWhatsAppFichaCuba(
        ventaPreparada,
        ventanaWhatsApp
      );
    } catch (e) {
      console.error(
        "❌ Error preparando Ficha Cuba:",
        e
      );

      if (
        ventanaWhatsApp &&
        !ventanaWhatsApp.closed
      ) {
        ventanaWhatsApp.close();
      }

      alert(
        e?.response?.data?.error ||
          e?.response?.data?.message ||
          e?.message ||
          "No se pudo preparar la Ficha Cuba."
      );
    }
  },
  [
    enriquecerVenta,
    esManagerMiami,
  ]
);

  const columns = useMemo(
    () => [
            {
        id: "pago",
        Header: "Pago",
        accessor: "_id",
        width: 55,
        Cell: ({ row }) => (
          <button
            className="action-btn action-btn--pay"
            title="Pagos de venta"
            onClick={() => abrirPago(row.original)}
            disabled={
              pagoLoadingId === row.original._id ||
              row.original.estado === "ANULADA"
            }
          >
            <i className="fa fa-money" aria-hidden="true" />
          </button>
        ),
      },

      {
        id: "ver",
        Header: "Ver",
        accessor: "_id",
        width: 50,
        Cell: ({ row }) => (
          <button
            className="action-btn action-btn--view"
            title="Ver venta"
            onClick={() => abrirFicha(row.original)}
            disabled={fichaLoadingId === row.original._id}
          >
            <i className="fa fa-eye" aria-hidden="true" />
          </button>
        ),
      },

      {
        id: "editar",
        Header: "Edita",
        accessor: "_id",
        width: 55,

        Cell: ({ row }) => {
          const anulada =
            row.original.estado === "ANULADA";

          const tienePagos =
            ventaTienePagos(row.original);

          const ventaMiami =
            esVentaMiamiPropia(row.original);

          const managerPuedeGestionar =
            esManagerMiami &&
            ventaMiami;

          const bloqueadaPorSedeManager =
            esManagerMiami &&
            !ventaMiami;

          /*
            Con pagos:
            - ADMIN / ROOT pueden editar.
            - MANAGER MIAMI puede editar ventas MIAMI.
            - VENDEDOR sigue bloqueado como hasta ahora.
          */
          const bloqueadaPorPagos =
            tienePagos &&
            !esAdmin &&
            !managerPuedeGestionar;

          const bloqueada =
            anulada ||
            bloqueadaPorSedeManager ||
            bloqueadaPorPagos;

            let titulo = "Editar venta";

            if (anulada) {
              titulo =
                "No se puede editar una venta anulada";
            } else if (bloqueadaPorSedeManager) {
              titulo =
                "Venta de otra sede - Solo lectura";
            } else if (
              tienePagos &&
              (esAdmin || managerPuedeGestionar)
            ) {
              titulo =
                "Editar venta con pagos cargados";
            } else if (bloqueadaPorPagos) {
              titulo =
                "Venta con pagos - Edición restringida";
            }

          return (
            <button
              className="action-btn action-btn--edit"
              title={titulo}
              onClick={() => {
                if (anulada) {
                  mostrarAvisoEditar(
                    "No se puede editar una venta anulada.",
                    "Venta anulada"
                  );

                  return;
                }

                if (bloqueadaPorSedeManager) {
                  mostrarAvisoEditar(
                    "Esta venta pertenece a otra sede. El Manager Miami puede consultarla por la participación de un colaborador Miami, pero no modificarla.",
                    "Venta solo lectura"
                  );

                  return;
                }

                if (bloqueadaPorPagos) {
                  mostrarAvisoEditar(
                    "Esta venta tiene pagos cargados. Solo un administrador puede modificarla.",
                    "Edición restringida"
                  );

                  return;
                }

                abrirEditar(
                  row.original
                );
              }}
              disabled={
                editLoadingId ===
                row.original._id
              }
            >
              
              <i
                className="fa fa-pencil"
                aria-hidden="true"
              />
            </button>
          );
        },
      },

      {
        id: "pdf",
        Header: "PDF",
        accessor: "_id",
        width: 50,
        Cell: ({ row }) => (
          <button
            className="action-btn action-btn--pdf"
            title="PDF venta"
            onClick={() => generarPdfVenta(row.original)}
            disabled={pdfLoadingId === row.original._id}
          >
            <i className="fa fa-file-pdf-o" aria-hidden="true" />
          </button>
        ),
      },
      {
        id: "comprobantes",
        Header: () => <div className="th-center">Comp.</div>,
        accessor: "comprobantes",
        width: 50,
        Cell: ({ row }) => {
          const estadoDocs = estadoComprobantesVenta(row.original);

          return (
            <div className="td-center">
              <button
                className={`action-btn action-btn--docs-${estadoDocs}`}
                title={tituloComprobantesVenta(row.original)}
                onClick={() => abrirComprobantes(row.original)}
                disabled={row.original.estado === "ANULADA"}
              >
                <i className="fa fa-paperclip" aria-hidden="true" />
              </button>
            </div>
          );
        },
      },
      {
        id: "whatsapp",
        Header: () => <div className="th-center">Wsp</div>,
        accessor: "_id",
        width: 44,
        minWidth: 44,
        maxWidth: 44,
        disableFilters: true,
        Cell: ({ row }) => {
          const aviso = row.original?.whatsappAviso || {};
          const veces = Number(aviso.veces || 0);
          const enviado = !!aviso.enviado || veces > 0;

          const claseWhatsapp = enviado
            ? "action-btn--whatsapp-sent"
            : "action-btn--whatsapp-pending";

          const titulo = enviado
            ? `WhatsApp enviado ${veces || 1} vez/veces`
            : "Enviar datos por WhatsApp";

          return (
            <div className="td-center">
              <button
                className={`action-btn action-btn--small ${claseWhatsapp}`}
                title={titulo}
                onClick={() => enviarWhatsAppDesdeListado(row.original)}
                disabled={
                    esManagerMiami &&
                    !esVentaMiamiPropia(row.original)
                  }
              >
                <i className="fa fa-whatsapp" aria-hidden="true" />
              </button>
            </div>
          );
        },
      },

      {
        id: "seguimiento",
        Header: () => <div className="th-center">Seg.</div>,
        accessor: "_id",
        width: 50,
        minWidth: 50,
        maxWidth: 50,
        disableFilters: true,
        Cell: ({ row }) => (
          <div className="td-center">
            <button
              type="button"
              className="action-btn action-btn--small action-btn--seguimiento"
              title="Seguimiento del cliente"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                abrirSeguimientoCliente(row.original);
              }}
              disabled={!row.original?.clienteCompra}
            >
              <i className="fa fa-sticky-note-o" aria-hidden="true" />
            </button>
          </div>
        ),
      },
      
      {
        id: "recepcion",
        Header: "Recep.",
        accessor: "_id",
        width: 60,

        Cell: ({ row }) => {
          const pendiente =
            getEstadoRecepcion(row.original) ===
            "PENDIENTE";

          if (!pendiente) {
            return (
              <div className="td-center">
                <span
                  title="Recepción completa"
                  style={{
                    color: "#198754",
                    fontWeight: 900,
                  }}
                >
                  ✓
                </span>
              </div>
            );
          }

          return (
            <div className="td-center">
              <button
                type="button"
                className="action-btn"
                style={{
                  background: "#f59e0b",
                  color: "#ffffff",
                }}
                title="Completar receptor"
                onClick={() =>
                  abrirCompletarReceptor(
                    row.original
                  )
                }
                disabled={
                  recepcionLoadingId ===
                    row.original._id ||
                  row.original.estado ===
                    "ANULADA" ||
                  (
                    esManagerMiami &&
                    !esVentaMiamiPropia(row.original)
                  )
                }
              >
                {recepcionLoadingId ===
                row.original._id ? (
                  <Spinner
                    animation="border"
                    size="sm"
                  />
                ) : (
                  <i
                    className="fa fa-user-plus"
                    aria-hidden="true"
                  />
                )}
              </button>
            </div>
          );
        },
      },

      ...(esAdmin
        ? [
            {
              id: "anular",
              Header: "Anula",
              accessor: "_id",
              width: 55,
              Cell: ({ row }) => (
                <button
                  className="action-btn action-btn--cancel"
                  title="Anular venta"
                  onClick={() => anular(row.original)}
                  disabled={row.original.estado === "ANULADA"}
                >
                  <i className="fa fa-ban" aria-hidden="true" />
                </button>
              ),
            },
          ]
        : []),

      {
        id: "fichaCuba",
        Header: () => (
          <div className="th-center">
            Ficha Cuba
          </div>
        ),
        accessor: "_id",
        width: 80,
        minWidth: 80,
        disableFilters: true,

        Cell: ({ row }) => {
          const pendiente =
            getEstadoRecepcion(row.original) ===
            "PENDIENTE";

          const bloqueadaManager =
            esManagerMiami &&
            !esVentaMiamiPropia(row.original);

          return (
            <div className="td-center">
              <button
                type="button"
                className="action-btn action-btn--whatsapp"
                title={
                  pendiente
                    ? "Falta completar receptor Cuba"
                    : "Enviar Ficha Cuba por WhatsApp"
                }
                onClick={() =>
                  enviarFichaCubaDesdeListado(
                    row.original
                  )
                }
                disabled={
                  pendiente ||
                  bloqueadaManager ||
                  row.original.estado === "ANULADA"
                }
              >
                <i
                  className="fa fa-whatsapp"
                  aria-hidden="true"
                />
              </button>
            </div>
          );
        },
      },

      {
        Header: () => <div className="th-center">N°</div>,
        accessor: "nroventa",
        width: 60,
        Cell: ({ value }) => (
          <div className="td-center" style={{ fontWeight: 800 }}>
            {value || "-"}
          </div>
        ),
      },
      {
        Header: "Fecha",
        accessor: "_fechaTxt",
        width: 95,
      },
            {
        Header: "Vendedor",
        accessor: "_vendedorTxt",
        width: 150,
        Cell: ({ value }) => (
          <div title={value} style={{ textAlign: "left" }}>
            {value || "-"}
          </div>
        ),
      },
      {
        Header: "Cliente Compra",
        accessor: "_clienteCompraTxt",
        width: 230,
        Cell: ({ value }) => (
          <div title={value} style={{ textAlign: "left" }}>
            {value || "-"}
          </div>
        ),
      },
      {
        Header: "Productos",
        accessor: "_productosTxt",
        width: 360,
        Cell: ({ value }) => (
          <div title={value} style={{ textAlign: "left" }}>
            {value || "-"}
          </div>
        ),
      },
      {
        Header: "Cliente Recibe",
        accessor: "_clientesRecibenTxt",
        width: 230,
        Cell: ({ value }) => (
          <div title={value} style={{ textAlign: "left" }}>
            {value || "-"}
          </div>
        ),
      },
      {
        Header: "Recepción",
        accessor: "estadoRecepcion",
        width: 145,

        Cell: ({ value }) => {
          const pendiente =
            clean(value).toUpperCase() === "PENDIENTE";

          return (
            <span
              style={{
                display: "inline-block",
                padding: "4px 9px",
                borderRadius: 999,
                fontSize: 11,
                fontWeight: 800,

                background: pendiente
                  ? "#ffedd5"
                  : "#dcfce7",

                color: pendiente
                  ? "#9a3412"
                  : "#166534",

                border: pendiente
                  ? "1px solid #fdba74"
                  : "1px solid #86efac",
              }}
            >
              {pendiente
                ? "RECEPCIÓN PENDIENTE"
                : "COMPLETA"}
            </span>
          );
        },
      },

      {
        Header: "Items",
        accessor: "_cantidadItems",
        width: 60,
      },
      {
        Header: "Estado",
        accessor: "estado",
        width: 120,
        Cell: ({ row, value }) => (
          <select
            className="form-control form-control-sm"
            value={value || "PENDIENTE"}
            disabled={
              estadoLoadingId === row.original._id ||
              (
                esManagerMiami &&
                !esVentaMiamiPropia(row.original)
              )
            }
            onChange={(e) => cambiarEstado(row.original, e.target.value)}
            style={{
              fontSize: 12,
              height: 28,
              padding: "2px 4px",
            }}
          >
            <option value="PENDIENTE">PENDIENTE</option>
            <option value="CONFIRMADA">CONFIRMADA</option>
            <option value="EN_PROCESO">EN PROCESO</option>
            <option value="ENVIADA">ENVIADA</option>
            <option value="ENTREGADA">ENTREGADA</option>
          </select>
        ),
      },
      {
        Header: "Productos USD",
        accessor: "totalProductosUSD",
        width: 120,
        Cell: ({ value }) => formatUSD(value),
      },
      {
        Header: "Envío USD",
        accessor: "totalEnvioUSD",
        width: 105,
        Cell: ({ value }) => formatUSD(value),
      },
      {
        Header: "Total USD",
        accessor: "totalUSD",
        width: 115,
        Cell: ({ value }) => <b>{formatUSD(value)}</b>,
      },
      
      {
        Header: "Estado Pago",
        accessor: "estadoPago",
        width: 105,
        Cell: ({ value }) => (
          <span className={`estado-pill ${estadoPagoClass(value)}`}>
            {value || "PENDIENTE"}
          </span>
        ),
      },
      {
        Header: "Acreditado USD",
        accessor: "totalAcreditadoUSD",
        width: 120,
        Cell: ({ value }) => formatUSD(value),
      },
      {
        Header: "Saldo USD",
        accessor: "saldoPendienteUSD",
        width: 115,
        Cell: ({ value }) => (
          <b style={{ color: Number(value || 0) > 0 ? "#c62828" : "#198754" }}>
            {formatUSD(value)}
          </b>
        ),
      },

      {
        Header: "Comisión USD",
        accessor: "totalComisionCalculadaUSD",
        width: 120,
        Cell: ({ value }) => formatUSD(value),
      },
      {
        Header: "Bajo Mín.",
        accessor: "tienePreciosBajoMinimo",
        width: 80,
        Cell: ({ value }) => (value ? "Sí" : "No"),
      },

      {
        Header: "Colaborador",
        accessor: "_colaboradorTxt",
        width: 160,
        Cell: ({ value }) => (
          <div title={value} style={{ textAlign: "left" }}>
            {value || "-"}
          </div>
        ),
      },
      {
        Header: "Observaciones",
        accessor: "observaciones",
        width: 230,
        Cell: ({ value }) => (
          <div title={value} style={{ textAlign: "left" }}>
            {value || "-"}
          </div>
        ),
      },
    ],
    [
      abrirFicha,
      abrirPago,
      abrirSeguimientoCliente,
      abrirCompletarReceptor,
      anular,
      esAdmin,
      esManagerMiami,
      cambiarEstado,
      estadoLoadingId,
      fichaLoadingId,
      generarPdfVenta,
      pagoLoadingId,
      pdfLoadingId,
      recepcionLoadingId,
      enviarWhatsAppDesdeListado,
      enviarFichaCubaDesdeListado,
    ]
  );

  const tableKey = useMemo(
    () =>
      `${loading ? "loading" : "ready"}-${dataFiltrada.length}-${q}-${estadoFiltro}-${sedeFiltro}-${recepcionFiltro}-${desde}-${hasta}`,
    [
      loading,
      dataFiltrada.length,
      q,
      estadoFiltro,
      sedeFiltro,
      recepcionFiltro,
      desde,
      hasta,
    ]
  );

  return (
    <>
      <div className="container-xl mt-4">
        <div className="card border-0 shadow-sm">
          <div className="card-body">
            <h3 className="text-center mb-3">LISTADO DE VENTAS</h3>

            <div className="row g-2 align-items-end mb-3">
              <div className="col-md-2">
                <label className="form-label mb-0 small">Buscar</label>
                <input
                  className="form-control form-control-sm"
                  placeholder="n° / cliente / producto / recibe / estado"
                  value={q}
                  onChange={(e) => setQ(e.target.value)}
                />
              </div>

              <div className="col-md-1">
                <label className="form-label mb-0 small">Estado</label>
                <select
                  className="form-control form-control-sm"
                  value={estadoFiltro}
                  onChange={(e) => setEstadoFiltro(e.target.value)}
                >
                  <option value="">TODOS</option>
                  <option value="PENDIENTE">PENDIENTE</option>
                  <option value="CONFIRMADA">CONFIRMADA</option>
                  <option value="EN_PROCESO">EN PROCESO</option>
                  <option value="ENVIADA">ENVIADA</option>
                  <option value="ENTREGADA">ENTREGADA</option>
                  <option value="ANULADA">ANULADA</option>
                </select>
              </div>

              <div className="col-md-2">
                <label className="form-label mb-0 small">
                  Sede
                </label>

                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: 4,
                  }}
                  role="group"
                  aria-label="Filtro por sede"
                >
                  <button
                    type="button"
                    className={`btn btn-sm ${
                      sedeFiltro === ""
                        ? "btn-primary"
                        : "btn-outline-primary"
                    }`}
                    onClick={() => setSedeFiltro("")}
                  >
                    TODAS
                  </button>

                  <button
                    type="button"
                    className={`btn btn-sm ${
                      sedeFiltro === "MIAMI"
                        ? "btn-primary"
                        : "btn-outline-primary"
                    }`}
                    onClick={() => setSedeFiltro("MIAMI")}
                  >
                    MIAMI
                  </button>

                  <button
                    type="button"
                    className={`btn btn-sm ${
                      sedeFiltro === "YERBA BUENA"
                        ? "btn-primary"
                        : "btn-outline-primary"
                    }`}
                    onClick={() =>
                      setSedeFiltro("YERBA BUENA")
                    }
                  >
                    YERBA BUENA
                  </button>

                  <button
                    type="button"
                    className={`btn btn-sm ${
                      sedeFiltro === "TUCUMAN"
                        ? "btn-primary"
                        : "btn-outline-primary"
                    }`}
                    onClick={() =>
                      setSedeFiltro("TUCUMAN")
                    }
                  >
                    TUCUMAN
                  </button>
                </div>
              </div>

              <div className="col-md-1">
                <label className="form-label mb-0 small">
                  Recepción
                </label>

                <select
                  className="form-control form-control-sm"
                  value={recepcionFiltro}
                  onChange={(e) =>
                    setRecepcionFiltro(e.target.value)
                  }
                >
                  <option value="">TODAS</option>
                  <option value="COMPLETA">COMPLETAS</option>
                  <option value="PENDIENTE">
                    RECEPCIÓN PENDIENTE
                  </option>
                </select>
              </div>

              <div className="col-md-1">
                <label className="form-label mb-0 small">Desde</label>
                <input
                  type="date"
                  className="form-control form-control-sm"
                  value={desde}
                  onChange={(e) => setDesde(e.target.value)}
                />
              </div>

              <div className="col-md-1">
                <label className="form-label mb-0 small">Hasta</label>
                <input
                  type="date"
                  className="form-control form-control-sm"
                  value={hasta}
                  onChange={(e) => setHasta(e.target.value)}
                />
              </div>
              <div className="col-md-4">
                <div
                  className="d-flex flex-wrap gap-2 justify-content-end"
                >
                  <button
                    className="btn btn-outline-secondary btn-sm px-2"
                    onClick={() => {
                      setQ("");
                      setEstadoFiltro("");
                      setSedeFiltro("");
                      setDesde("");
                      setHasta("");
                      setRecepcionFiltro("");
                    }}
                  >
                    Limpiar
                  </button>

                  <button
                    className="btn btn-outline-primary btn-sm px-2"
                    onClick={fetchAll}
                    disabled={loading}
                  >
                    Recargar
                  </button>

                  <button
                    className="btn btn-success btn-sm px-2"
                    onClick={() =>
                      exportarExcelVentas(
                        allEnriquecidas,
                        "todo"
                      )
                    }
                    disabled={
                      loading ||
                      Boolean(exportando)
                    }
                  >
                    {exportando === "excel-todo"
                      ? "Preparando…"
                      : "Excel TODO"}
                  </button>

                  <button
                    className="btn btn-outline-success btn-sm px-2"
                    onClick={() =>
                      exportarExcelVentas(
                        dataFiltrada,
                        "vista"
                      )
                    }
                    disabled={
                      loading ||
                      Boolean(exportando)
                    }
                  >
                    {exportando === "excel-vista"
                      ? "Preparando…"
                      : "Excel VISTA"}
                  </button>

                  <button
                    className="btn btn-danger btn-sm px-2"
                    onClick={() =>
                      exportarPdfListado(
                        allEnriquecidas,
                        "todo"
                      )
                    }
                    disabled={
                      loading ||
                      Boolean(exportando)
                    }
                  >
                    {exportando === "pdf-todo"
                      ? "Preparando…"
                      : "PDF TODO"}
                  </button>

                  <button
                    className="btn btn-outline-danger btn-sm px-2"
                    onClick={() =>
                      exportarPdfListado(
                        dataFiltrada,
                        "vista"
                      )
                    }
                    disabled={
                      loading ||
                      Boolean(exportando)
                    }
                  >
                    {exportando === "pdf-vista"
                      ? "Preparando…"
                      : "PDF VISTA"}
                  </button>
                </div>
              </div>
            </div>

            <div className="row g-2 mb-3">
              <div className="col-md-2">
                <div className="border rounded p-2">
                  <div className="text-muted small">Mostrando</div>
                  <strong>
                    {loading
                      ? `${progress.loaded} / ${progress.total || "?"}`
                      : `${dataFiltrada.length} de ${all.length}`}
                  </strong>
                </div>
              </div>

              <div className="col-md-2">
                <div className="border rounded p-2">
                  <div className="text-muted small">Productos USD</div>
                  <strong>{formatUSD(totalesVista.productos)}</strong>
                </div>
              </div>

              <div className="col-md-2">
                <div className="border rounded p-2">
                  <div className="text-muted small">Envío USD</div>
                  <strong>{formatUSD(totalesVista.envio)}</strong>
                </div>
              </div>

              <div className="col-md-2">
                <div className="border rounded p-2">
                  <div className="text-muted small">Total USD</div>
                  <strong>{formatUSD(totalesVista.total)}</strong>
                </div>
              </div>

              <div className="col-md-2">
                <div className="border rounded p-2">
                  <div className="text-muted small">Acreditado USD</div>
                  <strong className="text-success">
                    {formatUSD(totalesVista.acreditado)}
                  </strong>
                </div>
              </div>

              <div className="col-md-1">
                <div className="border rounded p-2">
                  <div className="text-muted small">Saldo USD</div>
                  <strong
                    style={{
                      color: Number(totalesVista.saldo || 0) > 0 ? "#c62828" : "#198754",
                    }}
                  >
                    {formatUSD(totalesVista.saldo)}
                  </strong>
                </div>
              </div>

              <div className="col-md-1">
                <div className="border rounded p-2">
                  <div className="text-muted small">Comisión USD</div>
                  <strong>{formatUSD(totalesVista.comision)}</strong>
                </div>
              </div>
            </div>

            <Styles>
              <div className="table-container">
                <Table
                  key={tableKey}
                  columns={columns}
                  data={dataFiltrada}
                  loading={loading}
                  plugins={[useSortBy, usePagination]}
                  showExports={false}
                  getRowClassName={(ventaRow) =>
                    getEstadoRecepcion(ventaRow) === "PENDIENTE"
                      ? "venta-recepcion-pendiente"
                      : ""
                  }
                />
              </div>
            </Styles>
          </div>
        </div>
      </div>

      <Modal
        show={showFicha}
        onHide={() => setShowFicha(false)}
        size="xl"
        centered
        scrollable
      >

        <Modal.Header closeButton>
          <Modal.Title>Ficha de Venta</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {fichaLoadingId && !fichaData ? (
            <div className="text-center py-5">
              <Spinner animation="border" />
              <div className="mt-2">Cargando venta...</div>
            </div>
          ) : fichaData?.venta ? (
            <>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                  borderBottom: "1px solid #333",
                  paddingBottom: 12,
                  marginBottom: 16,
                }}
              >
                <div style={{ width: 160 }}>
                  <img
                    src={ridersLogo}
                    alt="Logo"
                    style={{
                      maxWidth: 130,
                      maxHeight: 55,
                      objectFit: "contain",
                    }}
                  />
                </div>

                <div
                  style={{
                    flex: 1,
                    textAlign: "center",
                    fontFamily: "serif",
                    fontWeight: "bold",
                    fontSize: 28,
                  }}
                >
                  FICHA DE VENTA
                </div>

                <div style={{ width: 170, textAlign: "right" }}>
                  <div style={{ fontWeight: "bold", fontSize: 18 }}>
                    N°: {textOrDash(fichaData.venta?.nroventa)}
                  </div>

                  <div style={{ fontSize: 13, marginTop: 8 }}>
                    Fecha emisión: {fmtDate(fichaData.fechaEmision)}
                  </div>
                </div>
              </div>

              <BsTable bordered size="sm" responsive style={{ fontSize: 13 }}>
                <tbody>
                  <tr>
                    <th style={{ width: "15%" }}>N° Venta</th>
                    <td style={{ width: "35%" }}>
                      {textOrDash(fichaData.venta?.nroventa)}
                    </td>

                    <th style={{ width: "15%" }}>Fecha</th>
                    <td style={{ width: "35%" }}>
                      {fmtDate(fichaData.venta?.fecha)}
                    </td>
                  </tr>

                  <tr>
                    <th>Cliente compra</th>
                    <td>{textOrDash(fichaData.venta?._clienteCompraTxt)}</td>

                    <th>Estado</th>
                    <td>
                      <span
                        className={`estado-pill ${estadoClass(
                          fichaData.venta?.estado
                        )}`}
                      >
                        {textOrDash(fichaData.venta?.estado)}
                      </span>
                    </td>
                  </tr>

                  <tr>
                    <th>Colaborador</th>
                    <td>{textOrDash(fichaData.venta?._colaboradorTxt)}</td>

                    <th>Vendedor</th>
                    <td>{textOrDash(fichaData.venta?._vendedorTxt)}</td>
                  </tr>

                  <tr>
                    <th>Total productos</th>
                    <td>{formatUSD(fichaData.venta?.totalProductosUSD)}</td>

                    <th>Total envío</th>
                    <td>{formatUSD(fichaData.venta?.totalEnvioUSD)}</td>
                  </tr>

                  <tr>
                    <th>Total venta</th>
                    <td>
                      <b>{formatUSD(fichaData.venta?.totalUSD)}</b>
                    </td>

                    <th>Comisión</th>
                    <td>
                      {formatUSD(fichaData.venta?.totalComisionCalculadaUSD)}
                    </td>
                  </tr>

                  <tr>
                    <th>Bajo mínimo</th>
                    <td>
                      {fichaData.venta?.tienePreciosBajoMinimo ? "Sí" : "No"}
                    </td>

                    <th>Observaciones</th>
                    <td>{textOrDash(fichaData.venta?.observaciones)}</td>
                  </tr>
                </tbody>
              </BsTable>

              {Array.isArray(fichaData.seguimientosCliente) &&
                fichaData.seguimientosCliente.length > 0 && (
                  <>
                    <h6 className="mt-4">Seguimiento del cliente</h6>

                    <BsTable bordered size="sm" responsive style={{ fontSize: 12 }}>
                      <thead>
                        <tr>
                          <th style={{ width: 90 }}>Fecha</th>
                          <th style={{ width: 110 }}>Estado</th>
                          <th style={{ width: 90 }}>Prioridad</th>
                          <th>Detalle</th>
                          <th style={{ width: 150 }}>Usuario</th>
                        </tr>
                      </thead>

                      <tbody>
                        {fichaData.seguimientosCliente.map((s) => (
                          <tr key={s._id || s.id || s.codseg}>
                            <td>{fmtDate(s.createdAt)}</td>

                            <td>
                              <span className={badgeSeguimiento(s.estado)}>
                                {textOrDash(String(s.estado || "").replace("_", " "))}
                              </span>
                            </td>

                            <td>
                              <span className={badgePrioridadSeguimiento(s.prioridad)}>
                                {textOrDash(s.prioridad)}
                              </span>
                            </td>

                            <td>{textOrDash(s.texto)}</td>

                            <td>{nombreUsuarioSistema(s.usuario) || "-"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </BsTable>
                  </>
                )}

              {(() => {
                const resumen = resumenFinanciero(
                  fichaData.venta,
                  fichaData.resumenPago
                );

                const pagos = Array.isArray(fichaData.pagos) ? fichaData.pagos : [];

                return (
                  <>
                    <h6 className="mt-4">Información financiera</h6>

                    <BsTable bordered size="sm" responsive style={{ fontSize: 13 }}>
                      <tbody>
                        <tr>
                          <th style={{ width: "15%" }}>Estado pago</th>
                          <td style={{ width: "35%" }}>
                            <span
                              className={`estado-pill ${estadoPagoClass(
                                resumen.estadoPago
                              )}`}
                            >
                              {resumen.estadoPago}
                            </span>
                          </td>

                          <th style={{ width: "15%" }}>Total venta</th>
                          <td style={{ width: "35%" }}>
                            <b>{formatUSD(resumen.totalVenta)}</b>
                          </td>
                        </tr>

                        <tr>
                          <th>Total cargado</th>
                          <td>{formatUSD(resumen.totalPagadoUSD)}</td>

                          <th>Total acreditado</th>
                          <td>
                            <b className="text-success">
                              {formatUSD(resumen.totalAcreditadoUSD)}
                            </b>
                          </td>
                        </tr>

                        <tr>
                          <th>Saldo pendiente</th>
                          <td>
                            <b
                              style={{
                                color:
                                  Number(resumen.saldoPendienteUSD || 0) > 0
                                    ? "#c62828"
                                    : "#198754",
                              }}
                            >
                              {formatUSD(resumen.saldoPendienteUSD)}
                            </b>
                          </td>

                          <th>Pagos cargados</th>
                          <td>{pagos.length}</td>
                        </tr>
                      </tbody>
                    </BsTable>

                    <h6 className="mt-3">Detalle de pagos</h6>

                    <BsTable bordered size="sm" responsive style={{ fontSize: 12 }}>
                      <thead>
                        <tr>
                          <th style={{ width: 45 }}>N°</th>
                          <th style={{ width: 70 }}>Fecha</th>
                          <th style={{ width: 145 }}>Medio</th>
                          <th style={{ width: 100 }}>Financiera</th>
                          <th style={{ width: 240 }}>Acomp./Garante</th>
                          <th style={{ width: 105 }} className="text-end">Monto</th>
                          <th style={{ width: 105 }}>Estado</th>
                          <th style={{ width: 85 }}>Fecha Acredit</th>
                          <th style={{ width: 75 }}>Firmado</th>
                          <th>Observaciones</th>
                        </tr>
                      </thead>

                      <tbody>
                        {pagos.length === 0 ? (
                          <tr>
                            <td colSpan={10} className="text-center text-muted">
                              No hay pagos cargados.
                            </td>
                          </tr>
                        ) : (
                          pagos.map((pago) => (
                            <tr key={pago._id || pago.id || pago.nropago}>
                              <td>{pago.nropago || "-"}</td>
                              <td>{fmtDate(pago.fechaPago)}</td>
                              <td>{textOrDash(pago.medioPago)}</td>
                              <td>{getNombreFinanciera(pago.financiera)}</td>

                              <td style={{ maxWidth: 180, fontSize: 11 }}>
                                {nombreClienteFinanciacionPago(
                                  pago,
                                  fichaData.venta?.clienteCompra
                                )}
                              </td>

                              <td className="text-end">
                                <b>{formatUSD(pago.montoUSD)}</b>
                              </td>

                              <td>
                                <span className={badgeAcreditacion(pago.estadoAcreditacion)}>
                                  {textOrDash(pago.estadoAcreditacion)}
                                </span>
                              </td>

                              <td>{fmtDate(pago.fechaAcreditacion)}</td>

                              <td className="text-center">
                                {clean(pago.medioPago).toUpperCase() === "CREDITO FINANCIERA" ? (
                                  <span
                                    className={
                                      pago.contratoFirmado
                                        ? "badge bg-success"
                                        : "badge bg-warning text-dark"
                                    }
                                  >
                                    {firmadoPagoTxt(pago)}
                                  </span>
                                ) : (
                                  "-"
                                )}
                              </td>

                              <td>{textOrDash(pago.observaciones)}</td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </BsTable>
                  </>
                );
              })()}


              <h6 className="mt-3">Ítems de la venta</h6>

              <BsTable bordered size="sm" responsive style={{ fontSize: 13 }}>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Producto</th>
                    <th>Cliente recibe</th>
                    <th>Cant.</th>
                    <th>Precio</th>
                    <th>Envío</th>
                    <th>Subtotal</th>
                    <th>Estado</th>
                  </tr>
                </thead>

                <tbody>
                  {(fichaData.venta.items || []).map((it, idx) => (
                    <tr key={it._id || idx}>
                      <td>{idx + 1}</td>
                      <td>{productoItemTxt(it)}</td>
                      <td>{clienteRecibeItemTxt(it)}</td>
                      <td>{Number(it.cantidad || 0)}</td>
                      <td>{formatUSD(it.precioVentaUSD)}</td>
                      <td>{formatUSD(it.costoEnvioUSD)}</td>
                      <td>{formatUSD(it.subtotalUSD)}</td>
                      <td>{textOrDash(it.estadoItem)}</td>
                    </tr>
                  ))}
                </tbody>
              </BsTable>
            </>
          ) : (
            <div className="text-muted">Sin datos para mostrar.</div>
          )}
        </Modal.Body>

        <Modal.Footer>
          {fichaData?.venta && (
            <Button
              variant="danger"
              onClick={() => generarPdfVenta(fichaData.venta)}
              disabled={pdfLoadingId === fichaData.venta?._id}
            >
              PDF
            </Button>
          )}

          <Button variant="secondary" onClick={() => setShowFicha(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>

      <ModalPagoVenta
        show={showPago}
        handleClose={cerrarPago}
        venta={ventaPago}
        onSaved={onPagoSaved}
        esManagerMiami={esManagerMiami}
        soloLectura={
          esManagerMiami &&
          !!ventaPago &&
          !esVentaMiamiPropia(ventaPago)
        }
      />

      <ModalEditarVentaCompleta
        show={showEditar}
        handleClose={cerrarEditar}
        venta={ventaEditar}
        onSaved={onVentaEditada}
      />

      <ModalComprobantesVenta
        show={showComprobantes}
        venta={ventaComprobantes}
        onHide={cerrarComprobantes}
        onVentaActualizada={onVentaComprobantesActualizada}
        soloLectura={
          esManagerMiami &&
          !!ventaComprobantes &&
          !esVentaMiamiPropia(ventaComprobantes)
        }
      />

      <ModalSeguimientoCliente
        show={!!ventaSeguimiento}
        venta={ventaSeguimiento}
        onHide={() => setVentaSeguimiento(null)}
        soloLectura={
          esManagerMiami &&
          !!ventaSeguimiento &&
          !esVentaMiamiPropia(ventaSeguimiento)
        }
        onSaved={() => {
          // luego agregamos contador visual
        }}
      />

      <ModalCompletarReceptor
        show={showCompletarReceptor}
        venta={ventaCompletarReceptor}
        onClose={cerrarCompletarReceptor}
        onSaved={onRecepcionGuardada}
      />

      <Modal
        show={avisoEditar.show}
        onHide={cerrarAvisoEditar}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton className="bg-dark text-white">
          <Modal.Title>{avisoEditar.titulo}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="d-flex align-items-start gap-3">
            <div
              style={{
                width: 46,
                height: 46,
                borderRadius: "50%",
                background: "#fff3cd",
                color: "#856404",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 24,
                fontWeight: "bold",
                flexShrink: 0,
              }}
            >
              !
            </div>

            <div>
              <h6 className="mb-2">La venta no puede editarse</h6>
              <p className="mb-0 text-muted">{avisoEditar.mensaje}</p>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="dark" onClick={cerrarAvisoEditar}>
            Entendido
          </Button>
        </Modal.Footer>
</Modal>
    </>
  );
}